import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesOrderService } from "../sales-order.service";
import * as _ from "lodash";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { AppMainService } from "src/app/app-main.service";
import { DialogType, TypeIds, ContactSelectionType, SOChannel } from "../constants/constants";
import { UtilityService } from "../utils/utility.service";
import { Status } from "../../constants/constants";
import { AccountsHttpService } from "src/app/modules/shared/services/accounts.http.service";
import { ICrediMemoProduct, ICreditMemo, ICreditMemoBundleProduct, ICreditMemoBundleProductList, ICreditMemoProductList } from "../models/credit-memo.model";
import { PaymenttermService } from "src/app/configurations/inventory/setup/paymentterm/paymentterm.service";
import { Subject, catchError, forkJoin, from, lastValueFrom, of, takeUntil } from "rxjs";
import { PaymentmethodService } from "src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service";
import { ShippingtermService } from "src/app/configurations/inventory/setup/shippingterm/shippingterm.service";
import { ProductsService } from "../../products/products.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "../services/account-flattening.service";
import { OverlayPanel } from "primeng/overlaypanel";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { DialogTypeFeeOrDiscount, Fee, FeeOrDiscountContext } from "src/app/modules/shared/components/fees-and-discounts-manager/models/fee.model";
import { ProductCalculationUtilityService } from "../utils/product-calculation-utility.service";
import { IPostingPeriodDetails } from "src/app/modules/shared/components/posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-credit-memo-add-edit",
    templateUrl: "./credit-memo-add-edit.component.html",
    styleUrls: ["./credit-memo-add-edit.component.scss"],
})
export class CreditMemoAddEditComponent implements OnInit, OnChanges {
    @Input() type;
    @Input() dialogHeader;
    @Input() displayCreditMemoAdd;
    @Input() accountChannels;
    @Input() footerTaxEnabled;
    @Input() footerDiscountEnabled;
    @Input() allShippingMethods: any;
    @Input() selectedCreditMemo: any;
    @Input() selectedEstimate: any;
    @Input() selectedReturn: any;
    @Input() selectedRPO: any;
    @Input() templates: any;
    @Input() allCustomAttributes: any;
    @Input() estimateObjectId;
    @Input() salesObjectId;
    @Input() invoiceObjectId;
    @Input() billingAddressType;
    @Input() shippingAddressType;
    @Input() isCreditVoid;
    @Input() showCreditVoidMsg;
    @Input() orgHeadOfficeAddress;
    @Input() selectedChannel: any;

    @Output() creditMemoDialogClose = new EventEmitter();
    @Output() cancel = new EventEmitter();
    @Output() confirm = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @ViewChild("editor") editor: any;
    @ViewChild("editCurrency") overlayPanel: OverlayPanel;

    isVisibleFooterTax = false;
    isVisibleFooterDiscount = false;
    allChecked: boolean = false;
    displayTracking: boolean = false;
    typeIds = TypeIds;
    dialogType = DialogType;
    contactType = ContactSelectionType;
    accountInfo;
    accountAddressInfo;
    shippingAddressInfo;
    contactInfo;
    selectedAccountAddress;
    selectedShippingAddress;
    orderStatusDD = [];
    minimumDate = this.app._saveDateTimeWithZone(new Date());
    allAccountsDD = [];
    displayAccountAddress = false;
    displayShippingAddress = false;
    allStages = [];
    allStatus = [];
    shippingMethods: any[] = [];
    filteredSection: any[] = [];
    minDate: Date = new Date(2000, 0, 1);
    minExpiryDate: Date = new Date(2000, 0, 1);
    maxDate: Date = new Date(2050, 11, 31);
    //product
    productsData;
    allProductsData;
    allProducts;
    purchaseListTB = [];
    selectedProductsList = [];
    measurementUnits = [];
    decimalPlacesMap: { [key: number]: number } = {};

    selectedBundle;
    orderTotal: number = 0;
    sumTotal: number = 0;
    discount: number = 0;
    taxRate: number = 0;
    tax: number = 0;
    productsTotal: number = 0;
    locationDD;
    displayScanInfo;
    triangle = "fa fa-caret-down";
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
    cmForm: FormGroup;
    // serial
    trackingForm: FormGroup;
    listLength = 0;
    nameLists = [];
    autoGenerateLists = [];
    noCaseFindOrLoadingText = "";
    disableLocation = true;
    cmDetails;
    taxDesc;
    selectedLocation;
    selectedProductForScan;
    selectedBundleForScan;
    selectedKitForScan;
    estimatesDetails;
    displayProductSelectionModal = false;
    moduleName: string = SOChannel.CREDIT_MEMO;
    isVisibleLocation = false;
    selectedLocationId = 0;
    headerText = "Products List";
    autoResize = true;
    isVisibleRowTax = false;
    isVisibleRowDiscount = false;
    shippingAddressContact;
    billingAddressContact;
    displayContactSelectionModal = false;
    contactSelectionModalType = "";
    selectedContact;
    cols = 0;
    statementMessege: string = "";
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    isDisabled = false;
    productSerialSettings;
    allAccounts = [];
    soChannel = SOChannel;

    //tracking
    disabledSave: boolean = false;
    isPrefix: boolean = false;
    isAutoGenerated: boolean = false;
    prefixValue: string = "";
    displayImport = false;
    totalTBRecord: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    pageSize: number = 100;
    first: number = 0;
    systemTrackingData = [];
    unMatchedSerials = [];
    @Input() trackingOptions = [];
    serialConfig;
    refId: string = "";
    importForAllProducts: boolean = false;
    customerReturnDetails: any;
    allTax = [];
    allTaxRates = [];
    allPaymentTerms = [];
    allPaymentMethods = [];
    allShippingTerms = [];
    allUser = [];
    allLocations = [];
    orderChannels = [];
    aggregateDiscount: boolean = false;
    pricebookConfig: boolean = false;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number;
    selectedAccountChannelId: number;

    discountOptions: any[] = [];
    additionalDiscounts: any[] = [];
    additionalDiscountRateTypes: any[] = [];

    // additional Fees
    additionalFees: any[] = [];
    totalAdditionalFee: number = 0;
    productsTotalAdditionalFee: number = 0;
    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;
    //footer & line level discount & fee
    selectedDProduct: any = null;
    selectedHProduct: any = null;
    lineLevelDiscounts: any[] = [];
    footerLevelDiscounts: any[] = [];
    lineLevelHandlingFees: any[] = [];
    footerLevelHandlingFees: any[] = [];
    FeeOrDiscountContext = FeeOrDiscountContext;
    feeOrDiscountContext: FeeOrDiscountContext;
    DialogTypeFeeOrDiscount = DialogTypeFeeOrDiscount;
    currentDialogType: DialogTypeFeeOrDiscount;
    displayFeeOrDiscountDialog = false;
    // currency
    baseCurrency: any;
    orgCurrency = [];
    currencyExchangeRate: number;
    savedCurrencyExchangeRate: number;
    previousCurrencyExchangeRate: number;

    // posting period
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    isAllowPostingPeriod: boolean = false;

    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        public datepipe: DatePipe,
        private appMainService: AppMainService,
        public utilityService: UtilityService,
        private accountsHttpService: AccountsHttpService,
        private paymentTermService: PaymenttermService,
        private paymentMethodService: PaymentmethodService,
        private shippingtermService: ShippingtermService,
        private productsService: ProductsService,
        private confirmationService: ConfirmationService,
        private importService: ImportserialService,
        private renderer: Renderer2,
        private accountServiceN: AccountServiceN,
        private accountFlatteningService: AccountFlatteningService,
        private utilService: UtilsService,
        private productCalculationUtilityService: ProductCalculationUtilityService,
    ) {}

    ngOnInit(): void {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
        this.getBaseCurrency();
        this.initForm();
        this.utilityService.getFilteredSectionsByType(6).subscribe((res) => {
            this.filteredSection = res;
        });
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayCreditMemoAdd && changes.displayCreditMemoAdd.currentValue) {
            this.displayCreditMemoAdd = changes.displayCreditMemoAdd.currentValue;
            this.isDisabled = false;
            this.checkTaxDiscountVisibility();
            this.getColsCount();
        }
        if (changes.allShippingMethods && changes.allShippingMethods.currentValue) {
            this.allShippingMethods = changes.allShippingMethods.currentValue;
            this.shippingMethods = this.utilityService.prepareShippingMethods(this.allShippingMethods);
        }
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
            this.initForm();
            this.loadData();
        }
    }

    initForm() {
        this.minExpiryDate = this.app._showDateTimeWithZone(new Date());
        this.cmForm = this.fb.group({
            id: [0],
            accountChannel: [this.accountChannels?.filter((ac) => ac.isDefault == true)[0]],
            account: ["", Validators.required],
            date: [this.app._showDateTimeWithZone(new Date())],
            expiryDate: [this.app._showDateTimeWithZone(new Date())],
            creditMemoStatus: [""],
            referenceNumber: [""],
            shippingChargeAmount: [0],
            taxAmount: [0],
            discountType: [null],
            discountValue: [0],
            vendorMessage: [""],
            memo: [""],
            paymentTerm: [""],
            paymentMethod: [""],
            shippingTerm: [""],
            shippingMethod: [""],
            salesRep: [""],
            tax: [""],
            location: [""],
            statusId: [true],
            additionalFeeType: [null],
            additionalFee: [0],
        });
        this.prepareTrackingForm();
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe((resp) => {
            this.measurementUnits = resp;
        });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    loadData() {
        this.appMainService.isShowSpinner("loadData");
        const taxObservable = this.salesOrderService.getAllTax().pipe(catchError((error) => this.handleError("Payment Term", error)));
        const orderChannelsObservable = this.salesOrderService.getAllOrdersChannel("Orders Type").pipe(catchError((error) => this.handleError("Order Channels", error)));
        const shippingTermObservable = this.shippingtermService.getShippingTermList().pipe(catchError((error) => this.handleError("Shipping Term", error)));
        const allUserObservable = this.salesOrderService.getAllUser().pipe(catchError((error) => this.handleError("All User", error)));
        const allLocationObservable = this.salesOrderService.getAllLocations("0", "0", "").pipe(catchError((error) => this.handleError("All Location", error)));
        const allTiersObservable = this.productsService.getAllTiers().pipe(catchError((error) => this.handleError("All Tiers", error)));
        const discountSelectionObservable = this.salesOrderService.getAllDiscountOption("TierApplicationRule").pipe(catchError((error) => this.handleError("Discount Selection", error)));
        const additionalDiscountObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Additional Discount", error)));
        const additionalFeesObservable = this.salesOrderService.getAdditionalFees().pipe(catchError((error) => this.handleError("Additional Fees", error)));

        forkJoin([taxObservable, orderChannelsObservable, shippingTermObservable, allUserObservable, allLocationObservable, allTiersObservable, discountSelectionObservable, additionalDiscountObservable, additionalFeesObservable]).subscribe(
            ([taxData, orderChannelData, shippingTermData, allUserData, allLocationData, allTiersData, discountSelectionData, additionalDiscounts, additionalFees]) => {
                this.setAllTaxData(taxData);
                this.setOrderChannelData(orderChannelData);
                this.setShippingTermData(shippingTermData);
                this.setAllUserData(allUserData);
                this.setAllLocationData(allLocationData);
                this.setAllTiersData(allTiersData);
                this.setDiscountSelectionData(discountSelectionData);
                this.setAdditionalDiscounts(additionalDiscounts);
                this.setAdditionalFees(additionalFees);

                if (this.type && this.type == DialogType.CREATE) {
                    this.filterActiveAccounts();
                    this.filterActiveLocations();
                    this.initCreditMemoDataToAddNew();
                } else if (this.type && [DialogType.EDIT, DialogType.COPY, DialogType.VIEW].includes(this.type)) {
                    this.initCreditMemoDataToEdit();
                } else if (this.type && this.type == DialogType.CONVERT_FROM_RMA) {
                    this.filterActiveAccounts();
                    this.filterActiveLocations();
                    this.initConvertToCreditMemoFromRMA();
                }
                this.appMainService.isHideSpinner("loadData");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }

    clearAccount(event) {
        this.cmForm.controls["account"].setValue("");
        this.cmForm.controls["paymentTerm"].setValue("");
        this.cmForm.controls["paymentMethod"].setValue("");
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        this.purchaseListTB = [];
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.findSum2();
        }
    }

    onChangeAccountChannel() {
        this.cmForm.controls["account"].setValue("");
        this.cmForm.controls["paymentTerm"].setValue("");
        this.cmForm.controls["paymentMethod"].setValue("");
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        this.purchaseListTB = [];
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.findSum2();
        }
    }
    setShippingMethodFormValue(id: number) {
        if (this.accountInfo && this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            this.cmForm.controls["shippingMethod"].setValue(this.utilityService.findShippingMethodById(this.shippingMethods, id));
        }
    }
    setDefaultShippingMethod() {
        if (this.shippingMethods && this.shippingMethods?.length > 0) {
            this.cmForm.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
    }

    getAllAccounts(channelId) {
        this.appMainService.isShowSpinner("loadSOAccounts");
        this.salesOrderService.getAccountsByChannelId(channelId, "").subscribe((responseData) => {
            this.appMainService.isHideSpinner("loadSOAccounts");
            this.allAccounts = responseData;
        });
    }

    filterActiveLocations() {
        const loc = _.cloneDeep(this.allLocations);
        this.allLocations = loc.filter((l) => l.statusId == 1);
    }

    filterActiveAccounts() {
        const acc = _.cloneDeep(this.allAccounts);
        this.allAccounts = acc.filter((a) => a.statusId == 1);
    }

    initCreditMemoDataToAddNew() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        this.customFields = this.utilityService.getCreditMemoCustomAttributes(this.templates, this.allCustomAttributes);
        // set default value
        if (this.shippingMethods && this.shippingMethods.length) {
            this.cmForm.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
        if (this.allLocations && this.allLocations.length) {
            this.cmForm.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
        if (this.allAccounts && this.allAccounts.length) {
            this.cmForm.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac.isDefault == true)[0]);
        }
        if(this.accountChannels && this.accountChannels?.length > 0) {
            this.cmForm.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac?.id == this.selectedChannel?.id)[0]);
        }

        this.cmForm.controls["creditMemoStatus"].setValue(this.allStatus[0]);
        this.cmForm.controls["date"].setValue(this.app._showDateTimeWithZone(new Date()));
        this.cmForm.controls["tax"].setValue(this.taxDesc);
        this.taxRate = this.taxDesc && this.taxDesc?.taxRate ? this.taxDesc?.taxRate : 0;
    }

    initConvertToCreditMemoFromRMA() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];

        this.customFields = this.utilityService.getCreditMemoCustomAttributes(this.templates, this.allCustomAttributes);

        // set default value
        if (this.shippingMethods && this.shippingMethods.length) {
            this.cmForm.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
        if (this.allLocations && this.allLocations.length) {
            this.cmForm.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
        if (this.allAccounts && this.allAccounts.length) {
            this.cmForm.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac.isDefault == true)[0]);
        }
        this.cmForm.controls["creditMemoStatus"].setValue(this.allStatus[0]);
        this.cmForm.controls["tax"].setValue(this.taxDesc);
        this.taxRate = this.taxDesc && this.taxDesc?.taxRate ? this.taxDesc?.taxRate : 0;

        this.appMainService.isHideSpinner("loadCreditMemo");
        this.salesOrderService.getCustomerReturnDetailsToConvert(this.selectedReturn.id).subscribe(
            async (res) => {
                this.customerReturnDetails = _.cloneDeep(res);
                this.savedCurrencyExchangeRate = Number(this.customerReturnDetails.exchangeRate);
                this.accountInfo = this.customerReturnDetails?.account;
                if (this.accountInfo) {
                    this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
                }
                this.getcurrencyExchangeRate();
                const wh = this.allLocations?.filter((l) => l.id == this.customerReturnDetails?.warehouseId)[0];
                this.selectedLocation = wh;
                const user = this.allUser?.filter((u) => u.id == this.customerReturnDetails?.userId)[0];
                const term = this.allPaymentTerms.filter((pt) => pt.id == this.customerReturnDetails.invoice.paymentTermId)[0];
                if (!term) {
                    this.allPaymentTerms.push(this.customerReturnDetails.invoice.paymentTerm);
                }
                const method = this.allPaymentMethods.filter((pm) => pm.id == this.customerReturnDetails.invoice.paymentMethodId)[0];
                if (!method) {
                    this.allPaymentMethods.push(this.customerReturnDetails.invoice.paymentMethod);
                }
                this.cmForm.patchValue({
                    ...this.customerReturnDetails,
                    account: this.accountInfo,
                    accountChannel: this.accountChannels?.filter((ac) => ac.id == this.customerReturnDetails?.account?.typeId)[0],
                    date: this.app._showDateTimeWithZone(new Date()),
                    expiryDate: this.app._showDateTimeWithZone(new Date()),
                    creditMemoStatus: this.allStatus.filter((s) => s.id == 1)[0],
                    discountType: "",
                    vendorMessage: "",
                    memo: "",
                    salesRep: user,
                    location: wh,
                    shippingChargeAmount: this.customerReturnDetails.shippingCharge ? (Number(this.customerReturnDetails.shippingCharge) * Number((this.customerReturnDetails?.exchangeRate ?? 1))).toFixed(this.fractionDigits) : 0,
                    statusId: this.customerReturnDetails.statusId == 1 ? true : false,
                });
                this.setContentInEditor("");

                // billing address
                this.selectedAccountAddress = this.customerReturnDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.customerReturnDetails?.billingAddressId)[0];
                this.accountAddressInfo = this.selectedAccountAddress;

                // shipping address
                this.selectedShippingAddress = this.customerReturnDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.customerReturnDetails?.shippingAddressId)[0];
                this.shippingAddressInfo = this.selectedShippingAddress;
                // contact
                this.billingAddressContact = this.customerReturnDetails?.contact;
                this.shippingAddressContact = this.customerReturnDetails?.shipContact;

                if (this.customerReturnDetails && this.customerReturnDetails?.customerRMAProducts.length) {
                    for (let l of this.customerReturnDetails?.customerRMAProducts) {
                        const uom = l.product.productUOM.filter((po) => po.unitOfMeasureId == l.productUOMId)[0];
                        const pDiscType = this.discountOptions?.filter((v) => v.id == l.discountId)[0];
                        let totalAvailQty = 0;
                        if (l.productWarehouseDetailDTO && l.productWarehouseDetailDTO.length > 0) {
                            l.productWarehouseDetailDTO.forEach((e) => {
                                totalAvailQty += e.availQty;
                            });
                        }
                        // bundle items
                        const bundleDetail: ICreditMemoBundleProductList[] = [];
                        if (l.rmaBundleDetails?.length > 0) {
                            l.rmaBundleDetails.forEach((b) => {
                                //kit under kit items
                                const kitDetail: ICreditMemoBundleProductList[] = [];
                                b.childRMABundleDto?.forEach((kp) => {
                                    const ku = kp?.product?.productUOM?.filter((o) => o.unitOfMeasureId == kp.productUOMId)[0];
                                    const kDiscType = this.discountOptions?.filter((v) => v.id == kp.discountId)[0];
                                    const obj: ICreditMemoBundleProductList = {
                                        id: kp.subProductId,
                                        rowId: kp.id,
                                        typeId: kp.product.typeId,
                                        itemNo: kp.product.itemNo,
                                        description: kp.description ? kp.description : "",
                                        uom: kp.product.productUOM,
                                        unit: ku,
                                        availabel: kp.availableQuantity,
                                        ordQty: kp.returnQuantity,
                                        originalQty: kp.originalQty,
                                        bundleQty: kp.returnQuantity,
                                        cost: Number(kp.product.productPrice.buyPrice ?? 0),
                                        price: Number(kp.pricePerProduct),
                                        originalprice: Number(kp.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == kp.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                                        accountPriceTier: kp.product?.accountProductPriceTiers,
                                        isCustom: kp.product?.isCustom,
                                        discountTypeName: kp.product?.tierTypeName,
                                        selectedTierId: kp.product?.selectedtierId,
                                        currentVal: kp.returnQuantity,
                                        cmBundleProductSerialDetail: [],
                                        discountType: kDiscType,
                                        taxType: 0, //b.tax,
                                        discount: 0, //this.getDiscountAmount(b, u?.uomDetail?.value || 1),
                                        discountAmount: 0, //b.discountAmount,
                                        taxAmount: 0, //this.getTaxAmount(b),
                                        subTotal: kp.totalAmount,
                                        baseSubTotal: kp.totalAmount,
                                        totalQuantity: kp.totalQty,
                                        isTrackingRequired: kp.product?.isTrackingRequired ? kp.product.isTrackingRequired : false,
                                        serialSettings: kp.product?.serialSettings ? JSON.parse(kp.product?.serialSettings) : null,
                                        warehouseId: kp?.product?.warehouseProduct[0]?.warehouseId,
                                        additionalFeeType: this.additionalFees?.find((af) => af.id == kp?.additionalFeesId),
                                        additionalFee: kp?.additionalRate ?? 0,
                                        additionalFeeAmount: kp?.additionalAmount ?? 0,
                                        costPrice: kp.costPrice ?? 0,
                                        totalCostPrice: kp.totalCostPrice ?? 0,
                                    };
                                    kitDetail.push(obj);
                                });
                                const u = b?.product?.productUOM?.filter((o) => o.unitOfMeasureId == b.productUOMId)[0];
                                const bDiscType = this.discountOptions?.filter((v) => v.id == b.discountId)[0];
                                const obj: ICreditMemoBundleProductList = {
                                    id: b.subProductId,
                                    rowId: b.id,
                                    typeId: b.product.typeId,
                                    itemNo: b.product.itemNo,
                                    description: b.description ? b.description : "",
                                    uom: b.product.productUOM,
                                    unit: u,
                                    availabel: b.availableQuantity,
                                    ordQty: b.returnQuantity,
                                    originalQty: b.originalQty,
                                    bundleQty: b.returnQuantity,
                                    cost: Number(b.product.productPrice.buyPrice ?? 0),
                                    price: Number(b.pricePerProduct),
                                    originalprice: Number(b.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == b.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                                    accountPriceTier: b.product?.accountProductPriceTiers,
                                    isCustom: b.product?.isCustom,
                                    discountTypeName: b.product?.tierTypeName,
                                    selectedTierId: b.product?.selectedtierId,
                                    currentVal: b.returnQuantity,
                                    bundleDetails: kitDetail,
                                    cmBundleProductSerialDetail: [],
                                    discountType: bDiscType,
                                    taxType: 0, //b.tax,
                                    discount: 0, //this.getDiscountAmount(b, u?.uomDetail?.value || 1),
                                    discountAmount: 0, //b.discountAmount,
                                    taxAmount: 0, //this.getTaxAmount(b),
                                    subTotal: b.totalAmount,
                                    baseSubTotal: b.totalAmount,
                                    totalQuantity: b.totalQty,
                                    isTrackingRequired: b.product?.isTrackingRequired ? b.product.isTrackingRequired : false,
                                    serialSettings: b.product?.serialSettings ? JSON.parse(b.product?.serialSettings) : null,
                                    warehouseId: b?.product?.warehouseProduct[0]?.warehouseId,
                                    additionalFeeType: this.additionalFees?.find((af) => af.id == b?.additionalFeesId),
                                    additionalFee: b?.additionalRate ?? 0,
                                    additionalFeeAmount: b?.additionalAmount ?? 0,
                                    costPrice: b.costPrice ?? 0,
                                    totalCostPrice: b.totalCostPrice ?? 0,
                                };
                                bundleDetail.push(obj);
                            });
                        }

                        const eachProduct = {
                            id: l.productId,
                            rowId: l.id,
                            itemNo: l.product.itemNo,
                            description: l.description ? l.description : "",
                            uom: l.product.productUOM,
                            unit: uom,
                            availabel: totalAvailQty,
                            ordQty: l.returnQuantity,
                            originalQty: l.originalQty,
                            cost: Number(l.product.productPrice.buyPrice ?? 0),
                            price: Number(l.pricePerProduct),
                            originalprice: Number(l.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == l.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                            accountPriceTier: l.product?.accountProductPriceTiers,
                            isCustom: l.product?.isCustom,
                            discountTypeName: l.product?.tierTypeName,
                            selectedTierId: l.product?.selectedtierId,
                            currentVal: l.quantity,
                            customerRMAProductSerialDetails: l.customerRMAProductSerialDetail,
                            typeId: l.product.typeId,
                            bundleDetails: bundleDetail, // bundle that saved with customerReturn
                            productBundleLink: l.product.productBundleLink, // actual bundle that has all products
                            discountType: pDiscType,
                            taxType: 0, //l.tax,
                            discount: 0, //this.getDiscountAmount(l, uom?.uomDetail?.value),
                            discountAmount: 0, //l.discountAmount == null ? 0 : l.discountAmount,
                            taxAmount: 0, //this.getTaxAmount(l),
                            subTotal: l.totalAmount,
                            baseSubTotal: l.totalAmount,
                            totalQuantity: l.totalQty,
                            isTrackingRequired: l.product?.isTrackingRequired ? l.product.isTrackingRequired : false,
                            serialSettings: l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null,
                            warehouseId: l?.product?.warehouseProduct[0]?.warehouseId,
                            additionalFeeType: this.additionalFees?.find((af) => af.id == l?.additionalFeesId),
                            additionalFee: l?.additionalRate ?? 0,
                            additionalFeeAmount: l?.additionalAmount ?? 0,
                            costPrice: l.costPrice ?? 0,
                            totalCostPrice: l.totalCostPrice ?? 0,
                        };
                        this.allProductsData.push(eachProduct);
                    }
                }
                this.purchaseListTB = this.allProductsData;
                this.selectedProductsList = this.purchaseListTB;
                this.purchaseListTB.forEach((element) => {
                    if (element.typeId == this.typeIds.BundleTypeId) {
                        let total = 0;
                        if (element.bundleDetails && element.bundleDetails.length) {
                            element.bundleDetails.forEach((e) => {
                                total += e.subTotal;
                            });
                        }
                        element.subTotal = total;
                    }
                });
                this.findSum2();

                //populate saved custom field data
                Object.keys(this.customFields).forEach((key) => {
                    const dataArr = this.customFields[key];
                    if (dataArr && dataArr.length > 0) {
                        dataArr.forEach((element) => {
                            const filteredCustom = this.customerReturnDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];

                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        });
                    }
                });
                // if type is edit location dropdown is disabled
                this.cmForm.controls.location.disable();
            },
            (err) => {
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    initCreditMemoDataToEdit() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.purchaseListTB = [];
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.serialConfig = iSettings?.find((value) => value.code == "enableserial");

        this.appMainService.isShowSpinner("loadCreditMemo");
        this.salesOrderService.getCreditMemoById(this.selectedCreditMemo.id).subscribe(
            (res) => {
                this.cmDetails = _.cloneDeep(res);
                this.savedCurrencyExchangeRate = Number(this.cmDetails.exchangeRate);
                this.appMainService.isHideSpinner("loadCreditMemo");
                const wh = this.allLocations.filter((l) => l.id == this.cmDetails?.warehouseId)[0];
                this.selectedLocation = wh;
                this.templates = this.cmDetails && this.cmDetails.configJSON ? JSON.parse(this.cmDetails.configJSON) : this.templates;
                this.customFields = this.utilityService.getCreditMemoCustomAttributes(this.templates, this.allCustomAttributes);
                
                this.currentPostingPeriodInfo = {
                    postingDate: this.cmDetails?.postingDate,
                    postingMonth: this.cmDetails?.postingMonth,
                    postingYear: this.cmDetails?.postingYear
                };
                this.accountInfo = this.cmDetails?.account;
                if (this.accountInfo) {
                    this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
                }
                this.getcurrencyExchangeRate();
                this.selectedAccountAddress = this.cmDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.cmDetails?.billingAddressId)[0];
                this.accountAddressInfo = this.selectedAccountAddress;
                this.selectedShippingAddress = this.cmDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.cmDetails?.shippingAddressId)[0];
                this.shippingAddressInfo = this.selectedShippingAddress;
                this.billingAddressContact = this.cmDetails?.contact;
                this.shippingAddressContact = this.cmDetails?.shipContact;
                this.getColsCount();
                this.checkTaxDiscountVisibility();
                this.setPaymentTermAndMethodForEditView();
                this.setFormValueForEditView();

                // product
                this.discount = this.cmDetails?.discountAmount;
                this.taxRate = this.cmDetails?.tax && this.cmDetails?.tax?.taxRate ? this.cmDetails.tax.taxRate : 0;
                this.setProductsForEditView();

                //populate saved custom field data
                Object.keys(this.customFields).forEach((key) => {
                    const dataArr = this.customFields[key];
                    if (dataArr && dataArr.length > 0) {
                        dataArr.forEach((element) => {
                            const filteredCustom = this.cmDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];

                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        });
                    }
                });
                // if type is edit location dropdown is disabled
                this.cmForm.controls.location.disable();
                if (this.type == DialogType.VIEW) {
                    this.cmForm.disable();
                } else if (this.type == DialogType.COPY) {
                    this.cmForm.controls["creditMemoStatus"].setValue(this.allStatus[0]);
                    this.cmForm.controls["date"].setValue(this.app._showDateTimeWithZone(new Date()));
                    this.cmForm.controls["expiryDate"].setValue(this.app._showDateTimeWithZone(new Date()));
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }
    setPaymentTermAndMethodForEditView() {
        const paymentTerms = [];
        const paymentMethods = [];
        if (this.cmDetails?.account?.accountPaymentTerms) {
            this.cmDetails?.account?.accountPaymentTerms?.forEach((e) => {
                paymentTerms.push(e.paymentTerm);
            });
        }
        if (this.cmDetails?.account?.accountPaymentMethods) {
            this.cmDetails?.account?.accountPaymentMethods?.forEach((e) => {
                paymentMethods.push(e.paymentMethod);
            });
        }
        const term = paymentTerms.filter((pt) => pt.id == this.cmDetails.paymentTermId)[0];
        if (!term) {
            paymentTerms.push(this.cmDetails.paymentTerm);
        }
        const method = paymentMethods.filter((pm) => pm.id == this.cmDetails.paymentMethodId)[0];
        if (!method) {
            paymentMethods.push(this.cmDetails.paymentMethod);
        }
        this.allPaymentTerms = paymentTerms;
        this.allPaymentMethods = paymentMethods;
    }
    setFormValueForEditView() {
        const discType = this.cmDetails?.discountId ? this.discountOptions?.filter((v) => v.id == this.cmDetails?.discountId)[0] : null;
        const user = this.allUser?.filter((u) => u.id == this.cmDetails?.userId)[0];
        const wh = this.allLocations.filter((l) => l.id == this.cmDetails?.warehouseId)[0];
        const currentYear = this.app._showDateTimeWithZone(this.cmDetails?.creditMemoDate).getFullYear();
        this.minDate = new Date(currentYear, 0, 1);
        this.maxDate = new Date(currentYear, 11, 31);
        this.minExpiryDate = this.app._showDateTimeWithZone(this.cmDetails?.creditMemoDate);
        this.cmForm.patchValue({
            ...this.cmDetails,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.cmDetails?.account?.typeId)[0],
            date: this.app._showDateTimeWithZone(this.cmDetails?.creditMemoDate),
            expiryDate: this.app._showDateTimeWithZone(this.cmDetails?.expiryDate),
            creditMemoStatus: this.allStatus.filter((s) => s.id == this.cmDetails.creditMemoStatusId)[0],
            discountType: discType,
            discountValue: this.cmDetails?.discountRate ?? 0,
            vendorMessage: this.cmDetails?.creditMemoNotes && this.cmDetails?.creditMemoNotes.length > 0 ? this.cmDetails.creditMemoNotes[this.cmDetails.creditMemoNotes.length - 1].note.comment : "",
            memo: this.cmDetails?.creditMemoAudits && this.cmDetails?.creditMemoAudits.length > 0 ? this.cmDetails.creditMemoAudits[this.cmDetails.creditMemoAudits.length - 1].note.comment : "",
            salesRep: user,
            location: wh,
            shippingChargeAmount: this.cmDetails.shippingCharge ? (Number(this.cmDetails.shippingCharge) * Number(this.cmDetails?.exchangeRate ?? 1)).toFixed(this.fractionDigits) : 0,
            statusId: this.cmDetails.statusId == 1 ? true : false,
            shippingMethod: this.utilityService.findShippingMethodById(this.shippingMethods, this.cmDetails.shippingMethodId),
            additionalFeeType: this.additionalFees?.find((af) => af.id == this.cmDetails?.additionalFeesId),
            additionalFee: this.cmDetails?.additionalRate ?? 0,
        });
        this.setContentInEditor(this.cmDetails?.creditMemoAudits && this.cmDetails?.creditMemoAudits.length > 0 ? this.cmDetails.creditMemoAudits[this.cmDetails.creditMemoAudits.length - 1].note.comment : "");
    }
    setProductsForEditView() {
        if (this.cmDetails && this.cmDetails?.creditMemoProducts.length) {
            for (let l of this.cmDetails?.creditMemoProducts) {
                const uom = l.product.productUOM.filter((po) => po.unitOfMeasureId == l.productUOMId)[0];
                const pDiscType = this.discountOptions?.filter((v) => v.id == l.discountId)[0];
                let totalAvailQty = 0;
                if (l.productWarehouseDetailDTO && l.productWarehouseDetailDTO.length > 0) {
                    l.productWarehouseDetailDTO.forEach((e) => {
                        totalAvailQty += e.availQty;
                    });
                }

                // bundle items
                const bundleDetail: ICreditMemoBundleProductList[] = [];
                if (l.creditMemoBundleDetail) {
                    l.creditMemoBundleDetail.forEach((b) => {
                        //kit under kit items
                        const kitDetail: ICreditMemoBundleProductList[] = [];
                        b.childCreditMemoBundleDetail?.forEach((kp) => {
                            const ku = kp?.product?.productUOM?.filter((o) => o.unitOfMeasureId == kp.productUOMId)[0];
                            const kDiscType = this.discountOptions?.filter((v) => v.id == kp.discountId)[0];
                            const kitProduct: ICreditMemoBundleProductList = {
                                id: kp.subProductId,
                                rowId: kp.id,
                                typeId: kp.product.typeId,
                                itemNo: kp.product.itemNo,
                                description: kp.description ? kp.description : "",
                                uom: kp.product.productUOM,
                                unit: ku,
                                availabel: kp.availableQuantity,
                                ordQty: kp.quantity,
                                bundleQty: kp.quantity,
                                cost: Number(kp.product.productPrice.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                                price: Number(kp.pricePerProduct) * this.savedCurrencyExchangeRate,
                                originalprice: Number(kp.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == kp.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                                accountPriceTier: kp.product?.accountProductPriceTiers,
                                isCustom: kp.product?.isCustom,
                                discountTypeName: kp.product?.tierTypeName,
                                selectedTierId: kp.product?.selectedtierId,
                                currentVal: kp.quantity,
                                cmBundleProductSerialDetail: this.type == DialogType.COPY ? [] : kp.creditMemoBundleProductSerialDetail,
                                discountType: kDiscType,
                                taxType: kp.tax,
                                discount: kp.discountRate ?? 0,
                                discountAmount: Number(kp.discountAmount) * this.savedCurrencyExchangeRate,
                                taxAmount: this.getTaxAmount(kp) * this.savedCurrencyExchangeRate,
                                subTotal: Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                                baseSubTotal: Number(kp.subTotal) * this.savedCurrencyExchangeRate,
                                totalQuantity: kp.totalQty,
                                isTrackingRequired: kp.product?.isTrackingRequired ? kp.product.isTrackingRequired : false,
                                serialSettings: kp.product?.serialSettings ? JSON.parse(kp.product?.serialSettings) : null,
                                warehouseId: kp?.product?.warehouseProduct[0]?.warehouseId,
                                originalQty: kp.originalQty,
                                parentBundleId: kp.parentBundleId,
                                additionalFeeType: this.additionalFees?.find((af) => af.id == kp?.additionalFeesId),
                                additionalFee: kp?.additionalRate ?? 0,
                                additionalFeeAmount: Number(kp?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                                costPrice: Number(kp.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                                totalCostPrice: Number(kp.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                            };
                            kitDetail.push(kitProduct);
                        });

                        const u = b?.product?.productUOM?.filter((o) => o.unitOfMeasureId == b.productUOMId)[0];
                        const bDiscType = this.discountOptions?.filter((v) => v.id == b.discountId)[0];
                        const bundleProduct: ICreditMemoBundleProductList = {
                            id: b.subProductId,
                            rowId: b.id,
                            typeId: b.product.typeId,
                            itemNo: b.product.itemNo,
                            description: b.description ? b.description : "",
                            uom: b.product.productUOM,
                            unit: u,
                            availabel: b.availableQuantity,
                            ordQty: b.quantity,
                            bundleQty: b.quantity,
                            cost: Number(b.product.productPrice.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                            price: Number(b.pricePerProduct) * this.savedCurrencyExchangeRate,
                            originalprice: Number(b.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == b.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                            accountPriceTier: b.product?.accountProductPriceTiers,
                            isCustom: b.product?.isCustom,
                            discountTypeName: b.product?.tierTypeName,
                            selectedTierId: b.product?.selectedtierId,
                            currentVal: b.quantity,
                            cmBundleProductSerialDetail: this.type == DialogType.COPY ? [] : b.creditMemoBundleProductSerialDetail,
                            discountType: bDiscType,
                            taxType: b.tax,
                            discount: b.discountRate ?? 0,
                            discountAmount: Number(b.discountAmount) * this.savedCurrencyExchangeRate,
                            taxAmount: this.getTaxAmount(b) * this.savedCurrencyExchangeRate,
                            subTotal: Number(b.totalAmount) * this.savedCurrencyExchangeRate,
                            baseSubTotal: Number(b.subTotal) * this.savedCurrencyExchangeRate,
                            totalQuantity: b.totalQty,
                            isTrackingRequired: b.product?.isTrackingRequired ? b.product.isTrackingRequired : false,
                            serialSettings: b.product?.serialSettings ? JSON.parse(b.product?.serialSettings) : null,
                            warehouseId: b?.product?.warehouseProduct[0]?.warehouseId,
                            originalQty: b.originalQty,
                            bundleDetails: kitDetail,
                            additionalFeeType: this.additionalFees?.find((af) => af.id == b?.additionalFeesId),
                            additionalFee: b?.additionalRate ?? 0,
                            additionalFeeAmount: Number(b?.additionalAmount) ?? 0 * this.savedCurrencyExchangeRate,
                            costPrice: Number(b.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                            totalCostPrice: Number(b.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                        };
                        bundleDetail.push(bundleProduct);
                    });
                }

                const eachProduct: ICreditMemoProductList = {
                    id: l.productId,
                    rowId: l.id,
                    itemNo: l.product.itemNo,
                    description: l.description ? l.description : "",
                    uom: l.product.productUOM,
                    unit: uom,
                    availabel: totalAvailQty,
                    ordQty: l.quantity,
                    cost: Number(l.product.productPrice.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                    price: Number(l.pricePerProduct) * this.savedCurrencyExchangeRate,
                    originalprice: Number(l.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == l.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                    accountPriceTier: l.product?.accountProductPriceTiers,
                    isCustom: l.product?.isCustom,
                    discountTypeName: l.product?.tierTypeName,
                    selectedTierId: l.product?.selectedtierId,
                    currentVal: l.quantity,
                    creditMemoProductSerialDetails: this.type == DialogType.COPY ? [] : l.creditMemoProductSerialDetail,
                    typeId: l.product.typeId,
                    bundleDetails: bundleDetail, // bundle that saved with creditmemo
                    productBundleLink: l.product.productBundleLink, // actual bundle that has all products
                    discountType: pDiscType,
                    taxType: l.tax,
                    discount: l.discountRate ?? 0,
                    discountAmount: Number(l.discountAmount) * this.savedCurrencyExchangeRate,
                    taxAmount: this.getTaxAmount(l) * this.savedCurrencyExchangeRate,
                    subTotal: Number(l.totalAmount) * this.savedCurrencyExchangeRate,
                    baseSubTotal: Number(l.subTotal) * this.savedCurrencyExchangeRate,
                    totalQuantity: l.totalQty,
                    isTrackingRequired: l.product?.isTrackingRequired ? l.product.isTrackingRequired : false,
                    serialSettings: l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null,
                    warehouseId: l?.product?.warehouseProduct[0]?.warehouseId,
                    additionalFeeType: this.additionalFees?.find((af) => af.id == l?.additionalFeesId),
                    additionalFee: l?.additionalRate ?? 0,
                    additionalFeeAmount: Number(l?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    costPrice: Number(l.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                    totalCostPrice: Number(l.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                };
                this.allProductsData.push(eachProduct);
            }
        }
        this.purchaseListTB = this.allProductsData;
        this.selectedProductsList = this.purchaseListTB;
        this.purchaseListTB.forEach((element) => {
            if (element.typeId == this.typeIds.BundleTypeId) {
                let total = 0;
                if (element.bundleDetails && element.bundleDetails.length) {
                    element.bundleDetails.forEach((e) => {
                        total += e.subTotal;
                    });
                }
                element.subTotal = total;
            }
        });
        this.findSum2();
    }

    onRowSelectAccountAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(JSON.stringify(this.selectedAccountAddress));
        // contact
        if (this.accountAddressInfo && this.accountAddressInfo?.address && this.accountAddressInfo?.address?.attnContact) {
            this.billingAddressContact = this.accountAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.billingAddressContact = e?.contact;
                    }
                });
            }
        }
    }
    onRowSelectShippingAddress(e) {
        this.displayShippingAddress = false;
        this.shippingAddressInfo = JSON.parse(JSON.stringify(this.selectedShippingAddress));

        // contact
        if (this.shippingAddressInfo && this.shippingAddressInfo?.address && this.shippingAddressInfo?.address?.attnContact) {
            this.shippingAddressContact = this.shippingAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.shippingAddressContact = e?.contact;
                    }
                });
            }
        }
    }
    openContactSelectionModal(e) {
        if (e == ContactSelectionType.BILLING) {
            this.selectedContact = this.billingAddressContact;
        } else if (e == ContactSelectionType.SHIPPING) {
            this.selectedContact = this.shippingAddressContact;
        }
        this.contactSelectionModalType = e;
        this.displayContactSelectionModal = true;
    }
    onContactSelectionComplete(e) {
        this.displayContactSelectionModal = false;
        if (this.contactSelectionModalType == ContactSelectionType.BILLING) {
            this.billingAddressContact = e?.contact;
        } else if (this.contactSelectionModalType == ContactSelectionType.SHIPPING) {
            this.shippingAddressContact = e?.contact;
        }
    }
    onContactSelectionCancel() {
        this.contactSelectionModalType = "";
        this.displayContactSelectionModal = false;
    }

    async selectAccount(c) {
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        this.purchaseListTB = [];
        this.appMainService.isShowSpinner("loadCMAccountsAddress");
        if (this.accountInfo?.id !== c.value.id) {
            this.accountAddressInfo = null;
        }
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.value.id);
        this.getcurrencyExchangeRate();
        this.appMainService.isHideSpinner("loadCMAccountsAddress");

        // default billing and shipping address
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0) {
            const allBillAddress = this.accountInfo.accountAddresses.filter((a) => a.address?.addressTypeId == this.billingAddressType?.id);
            const allShipAddress = this.accountInfo.accountAddresses.filter((a) => a.address?.addressTypeId == this.shippingAddressType?.id);

            this.accountAddressInfo = allBillAddress ? allBillAddress.filter((b) => b.address?.isDefault == true)[0] : null;
            this.selectedAccountAddress = this.accountAddressInfo;
            this.shippingAddressInfo = allShipAddress ? allShipAddress.filter((s) => s.address?.isDefault == true)[0] : null;
            this.selectedShippingAddress = this.shippingAddressInfo;
        }
        if (this.shippingAddressInfo) {
            this.selectedShippingAddress = this.shippingAddressInfo;
        } else {
            this.shippingAddressInfo = this.accountAddressInfo;
            this.selectedShippingAddress = this.shippingAddressInfo;
        }

        //billing contact
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }

        // shipping contact
        if (this.shippingAddressInfo) {
            if (this.shippingAddressInfo.address && this.shippingAddressInfo.address.attnContactId) {
                this.shippingAddressContact = this.shippingAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.shippingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }
        this.displayAccountAddress = this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && !this.accountAddressInfo ? true : false;

        // set payment term associated with account
        let defaultTerms;
        this.allPaymentTerms = [];
        if (this.accountInfo?.accountPaymentTerms) {
            this.accountInfo?.accountPaymentTerms.forEach((e) => {
                if (this.type == "CREATE" && e.statusId == Status.Active) {
                    this.allPaymentTerms.push(e.paymentTerm);
                } else if (this.type == "EDIT" || this.type == DialogType.COPY) {
                    this.allPaymentTerms.push(e.paymentTerm);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultTerms = e.paymentTerm;
                }
            });
        }
        if (defaultTerms) {
            this.cmForm.controls["paymentTerm"].setValue(defaultTerms);
        }

        let defaultMethods;
        this.allPaymentMethods = [];
        if (this.accountInfo?.accountPaymentMethods) {
            this.accountInfo?.accountPaymentMethods.forEach((e) => {
                if (this.type == "CREATE" && e.statusId == Status.Active) {
                    this.allPaymentMethods.push(e.paymentMethod);
                } else if (this.type == "EDIT" || this.type == DialogType.COPY) {
                    this.allPaymentMethods.push(e.paymentMethod);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultMethods = e.paymentMethod;
                }
            });
        }
        if (defaultMethods) {
            this.cmForm.controls["paymentMethod"].setValue(defaultMethods);
        }

        /** Shipping method */
        if (this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            let defaultShippingMethod = this.accountInfo?.accountShippingMethods?.find((s) => s.isDefault == true);
            if (defaultShippingMethod) {
                this.setShippingMethodFormValue(defaultShippingMethod?.shippingMethodId);
            }
        }
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.findSum2();
        }
    }

    filterAccount(event) {
        let query = event.query;
        const typeId = this.cmForm.controls["accountChannel"].value?.id;
        query = event.query;

        this.appMainService.isShowSpinner("getAccountList");
        this.accountServiceN
            .getAccountsByNameWithHierarchy(typeId, query)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                    } else {
                        this.allAccountsDD = [];
                    }
                    this.appMainService.isHideSpinner("getAccountList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
                complete: () => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
            });
    }

    editAccountAddress() {
        this.displayAccountAddress = true;
    }

    editShippingAddress() {
        this.displayShippingAddress = true;
    }

    saveCreditMemo() {
        this.isCreditVoid = false;
        const isValid = this.utilityService.checkvalidation(this.customFields);
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.customFields);
        if (this.orderTotal < 0) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Total can not be negative...",
            });
        } else {
            if ((this.type == DialogType.CREATE || this.type == DialogType.COPY) && isValid) {
                this.addNewCreditMemo(customattributeList);
            } else if (this.type == DialogType.EDIT && isValid) {
                this.updateCreditMemo(customattributeList);
            } else if (this.type == DialogType.CONVERT_FROM_RMA && isValid) {
                this.createCreditMemoFromRma(customattributeList);
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please fill up all required field...",
                });
            }
        }
    }

    preparePruductsListToAddCreditMemo(): ICrediMemoProduct[] {
        const products: ICrediMemoProduct[] = [];
        this.purchaseListTB.forEach((product) => {
            // bundle items
            const bundleItems: ICreditMemoBundleProduct[] = [];
            let total = 0;
            let subTotal = 0;
            if (product.bundleDetails) {
                product.bundleDetails.forEach((e) => {
                    const obj: ICreditMemoBundleProduct = {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: e.description,
                        creditMemoId: 0,
                        productId: product.id,
                        subproductId: e.id,
                        parentProductId: 0,
                        parentBundleId: 0,
                        productUOMId: e?.unit?.unitOfMeasureId ?? 1,
                        availableQuantity: e.availabel,
                        quantity: e.ordQty,
                        pricePerProduct: e.price,
                        totalAmount: e.subTotal,
                        subTotal: e.baseSubTotal,

                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : this.utilityService.calculateDiscountPerProduct(e.subTotal, this.sumTotal, this.discount), // discount to be applied
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discountType?.incomeAccount ?? 0) : (this.cmForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discountType?.id ?? 0) : (this.cmForm.controls["discountType"]?.value?.id ?? 0),
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
                        discountName: "",

                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                        taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                        statusId: 1,
                        creditMemoProductId: 0,
                        creditMemoSerialNumber: null,
                        creditMemoBundleProductSerialDetail: e.cmBundleProductSerialDetail && e.cmBundleProductSerialDetail.length > 0 ? e.cmBundleProductSerialDetail : null,
                        binId: 0,
                        totalQty: e.totalQuantity,
                        additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: e.costPrice ?? 0,
                        totalCostPrice: e.totalCostPrice ?? 0,
                    };
                    total += Number(e.subTotal);
                    subTotal += Number(e.baseSubTotal);
                    bundleItems.push(obj);

                    //kit under kit items
                    e.bundleDetails.forEach((kp) => {
                        const obj: ICreditMemoBundleProduct = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            description: kp.description,
                            creditMemoId: 0,
                            productId: product.id,
                            subproductId: kp.id,
                            parentProductId: e.id,
                            parentBundleId: this.type == DialogType.CREATE ? 0 : kp.parentBundleId,
                            productUOMId: kp?.unit?.unitOfMeasureId ?? 1,
                            availableQuantity: kp.availabel,
                            quantity: kp.ordQty,
                            pricePerProduct: kp.price,
                            totalAmount: kp.subTotal,
                            subTotal: kp.baseSubTotal,

                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount), // discount to be applied
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.incomeAccount ?? 0) : (this.cmForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.id ?? 0) : (this.cmForm.controls["discountType"]?.value?.id ?? 0),
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : 0,
                            discountName: "",

                            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                            taxName: "",
                            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                            statusId: 1,
                            creditMemoProductId: 0,
                            creditMemoSerialNumber: null,
                            creditMemoBundleProductSerialDetail: kp.cmBundleProductSerialDetail && kp.cmBundleProductSerialDetail.length > 0 ? kp.cmBundleProductSerialDetail : null,
                            binId: 0,
                            totalQty: kp.totalQuantity,
                            additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                            additionalAmount: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                            additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                            costPrice: kp.costPrice ?? 0,
                            totalCostPrice: kp.totalCostPrice ?? 0,
                        };
                        bundleItems.push(obj);
                    });
                });
            }

            let productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : product.subTotal;
            let productTotalAmountOfSubTotal = product.typeId == TypeIds.BundleTypeId ? subTotal : product.baseSubTotal;
            const obj: ICrediMemoProduct = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                description: product.description,
                creditMemoId: 0,
                productId: product.id,
                productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
                quantity: product.ordQty,
                quantityInStock: product.availabel,
                pricePerProduct: product.price,
                totalAmount: productTotalAmount,
                subTotal: productTotalAmountOfSubTotal,
                warehouseId: 0,
                statusId: 1,
                creditMemoSerialNumber: null,
                creditMemoProductSerialDetail: product.invoiceProductSerialDetails && product.invoiceProductSerialDetails.length > 0 ? product.invoiceProductSerialDetails : null,
                binId: 0,
                creditMemoBundleDetail: bundleItems && bundleItems.length > 0 ? bundleItems : [],
                totalQty: product.totalQuantity,

                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                discountType: "",
                discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount), // discount to be applied,
                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? (product.discountType.incomeAccount ?? 0) : (this.cmForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? (product.discountType?.id ?? 0) : (this.cmForm.controls["discountType"]?.value?.id ?? 0),
                discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                discountName: "",

                taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? product.taxAmount : 0,
                taxName: "",
                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                additionalAmount: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                costPrice: product.costPrice ?? 0,
                totalCostPrice: product.totalCostPrice ?? 0,
            };
            products.push(obj);
        });
        return products;
    }
    addNewCreditMemo(customattributeList) {
        
        this.isDisabled = true;
        const fControl = this.cmForm.controls;
        const creditMemo: ICreditMemo = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
            number: "",
            name: "",
            businessName: this.accountInfo?.businessName,
            referenceNumber: "",
            warehouseId: fControl["location"].value ? fControl["location"].value.id : 0,
            creditMemoDate: this.app._saveDateTimeWithZone(fControl["date"].value),
            expiryDate: this.app._saveDateTimeWithZone(fControl["expiryDate"].value),
            description: "",
            organizationId: this.app.companyId,
            accountId: fControl["account"].value ? fControl["account"].value.id : 0,
            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
            userId: fControl["salesRep"].value ? fControl["salesRep"].value.id : 0,
            paymentMethodId: fControl["paymentMethod"].value ? fControl["paymentMethod"].value.id : 0,
            paymentTermId: fControl["paymentTerm"].value ? fControl["paymentTerm"].value.id : 0,
            shippingMethodId: fControl?.shippingMethod?.value?.id ?? 0,
            shippingFinancialId: fControl?.shippingMethod?.value?.financialAccountId ?? 0,
            shippingTermId: fControl["shippingTerm"].value ? fControl["shippingTerm"].value.id : 0,
            salesRep: fControl["salesRep"].value ? fControl["salesRep"].value.id : 0,
            totalAmount: this.sumTotal,
            pendingCreditAmount: this.orderTotal,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked && fControl["discountType"].value ? (fControl["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? (fControl["discountType"]?.value?.incomeAccount ?? 0) : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? (fControl["discountType"].value?.id ?? 0) : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? (fControl["discountValue"]?.value ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.id : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.financialAccountId : 0,
            netAmount: this.orderTotal,
            shippingCharge: fControl["shippingChargeAmount"].value ? fControl["shippingChargeAmount"].value : 0,
            creditMemoStatusId: fControl["creditMemoStatus"].value ? fControl["creditMemoStatus"].value.id : 0,
            typeId: 1,
            statusId: fControl["statusId"].value ? 1 : 2,
            creditMemoNotes: this.getCreditMemoNotesObj(),
            creditMemoAudits: this.getCreditMemoAuditsObj(),
            creditMemoProducts: this.preparePruductsListToAddCreditMemo(),
            customAttributeValues: this.setCustomAttributes(customattributeList),
            configJson: "",
            createdByUser: "",
            channelId: fControl.accountChannel.value?.id,
            additionalFeesId: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[7]?.isChecked ? this.totalAdditionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.cmForm.controls["date"].value),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (new Date(this.cmForm.controls["date"].value).getMonth() + 1),
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (new Date(this.cmForm.controls["date"].value).getFullYear()),
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
        };

        this.appMainService.isShowSpinner("loadCreditMemo");
        this.salesOrderService
            .createCreditMemo(creditMemo, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Credit Memo created successfully...",
                });
                this.creditMemoDialogClose.emit(false);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    prepareProductsListToUpdateCreditMemo() {
        const products = [];
        this.purchaseListTB.forEach((product) => {
            const existingProduct = this.cmDetails.creditMemoProducts.filter((s) => s.productId == product.id)[0];
            // bundle items
            const bundleItems = [];
            let total = 0;
            let subTotal = 0;
            if (product.bundleDetails && product.bundleDetails.length > 0) {
                product.bundleDetails.forEach((e) => {
                    const obj: ICreditMemoBundleProduct = {
                        id: e.rowId ? e.rowId : 0,
                        creditMemoProductId: product.rowId ? product.rowId : 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: e.description,
                        creditMemoId: this.cmDetails.id,
                        productId: product.id,
                        subproductId: e.id,
                        parentBundleId: 0,
                        parentProductId: 0,
                        productUOMId: e.unit && e.unit.unitOfMeasureId && e.unit.unitOfMeasureId ? e.unit.unitOfMeasureId : 0,
                        availableQuantity: e.availabel,
                        quantity: e.ordQty,
                        pricePerProduct: e.price,
                        totalAmount: e.subTotal,
                        subTotal: e.baseSubTotal,
                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : this.utilityService.calculateDiscountPerProduct(e.subTotal, this.sumTotal, this.discount), // discount to be applied,
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.id)[0],
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
                        discountName: "",
                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                        taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                        statusId: 1,
                        creditMemoSerialNumber: null,
                        creditMemoBundleProductSerialDetail: e.cmBundleProductSerialDetail && e.cmBundleProductSerialDetail.length > 0 ? e.cmBundleProductSerialDetail : null,
                        binId: 0,
                        totalQty: e.totalQuantity,
                        additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: e.costPrice ?? 0,
                        totalCostPrice: e.totalCostPrice ?? 0,
                    };
                    total += Number(e.subTotal);
                    subTotal += Number(e.baseSubTotal);
                    bundleItems.push(obj);
                    //kit under kit items
                    e.bundleDetails.forEach((kp) => {
                        const obj: ICreditMemoBundleProduct = {
                            id: kp.rowId ? kp.rowId : 0,
                            creditMemoProductId: product.rowId ? product.rowId : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            description: kp.description,
                            creditMemoId: this.cmDetails.id,
                            productId: product.id,
                            subproductId: kp.id,
                            parentProductId: e.id,
                            parentBundleId: kp.parentBundleId,
                            productUOMId: kp.unit && kp.unit.unitOfMeasureId && kp.unit.unitOfMeasureId ? kp.unit.unitOfMeasureId : 0,
                            availableQuantity: kp.availabel,
                            quantity: kp.ordQty,
                            pricePerProduct: kp.price,
                            totalAmount: kp.subTotal,
                            subTotal: kp.baseSubTotal,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount), // discount to be applied,
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.id)[0],
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.disount ?? 0) : 0,
                            discountName: "",
                            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                            taxName: "",
                            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                            statusId: 1,
                            creditMemoSerialNumber: null,
                            creditMemoBundleProductSerialDetail: kp.cmBundleProductSerialDetail && kp.cmBundleProductSerialDetail.length > 0 ? kp.cmBundleProductSerialDetail : null,
                            binId: 0,
                            totalQty: kp.totalQuantity,
                            additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                            additionalAmount: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                            additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                            costPrice: kp.costPrice ?? 0,
                            totalCostPrice: kp.totalCostPrice ?? 0,
                        };
                        bundleItems.push(obj);
                    });
                });
            }

            let productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : product.subTotal;
            let productTotalAmountOfBaseSubTotal = product.typeId == TypeIds.BundleTypeId ? subTotal : product.baseSubTotal;
            const obj: ICrediMemoProduct = {
                id: existingProduct ? existingProduct.id : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                description: product.description,
                creditMemoId: this.cmDetails.id,
                productId: product.id,
                productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
                quantity: product.ordQty,
                quantityInStock: product.availabel,
                pricePerProduct: product.price,
                totalAmount: productTotalAmount,
                subTotal: productTotalAmountOfBaseSubTotal,
                warehouseId: 0,
                statusId: 1,
                creditMemoSerialNumber: null,
                creditMemoProductSerialDetail: product.creditMemoProductSerialDetails && product.creditMemoProductSerialDetails.length > 0 ? product.creditMemoProductSerialDetails : null,
                binId: 0,
                creditMemoBundleDetail: bundleItems && bundleItems.length > 0 ? bundleItems : [],
                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType.discountBy ?? 0) : (this.cmForm?.controls["discountType"]?.value?.discountBy ?? 0),
                discountType: "",
                discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount), // discount to be applied
                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.cmForm.controls["discountType"]?.value?.id).map((value) => value.id)[0],
                discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                discountName: "",
                taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? product.taxAmount : 0,
                taxName: "",
                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                totalQty: product.totalQuantity,
                additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                additionalAmount: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                costPrice: product.costPrice ?? 0,
                totalCostPrice: product.totalCostPrice ?? 0,
            };
            products.push(obj);
        });
        return products;
    }
    updateCreditMemo(customattributeList) {
        this.isDisabled = true;
        const fControl = this.cmForm.controls;
        const creditMemo = _.cloneDeep(this.cmDetails);
        creditMemo.updatedSource = this.app.userIP;
        creditMemo.updatedBy = this.app.user.userId;
        creditMemo.updatedDate = this.app._saveDateTimeWithZone(new Date());
        creditMemo.organizationId = this.app.companyId;
        creditMemo.creditMemoDate = this.app._saveDateTimeWithZone(fControl["date"].value);
        creditMemo.expiryDate = this.app._saveDateTimeWithZone(fControl["expiryDate"].value);
        creditMemo.contactId = this.billingAddressContact ? this.billingAddressContact.id : 0;
        creditMemo.shipContactId = this.shippingAddressContact ? this.shippingAddressContact.id : 0;
        creditMemo.warehouseId = fControl["location"].value ? fControl["location"].value.id : 0;
        creditMemo.referenceNumber = "";
        creditMemo.accountId = fControl["account"].value ? fControl["account"].value.id : 0;
        creditMemo.billingAddressId = this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0;
        creditMemo.shippingAddressId = this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0;
        creditMemo.warehouseId = fControl["location"].value ? fControl["location"].value.id : 0;
        creditMemo.userId = fControl["salesRep"].value ? fControl["salesRep"].value.id : 0;
        creditMemo.paymentMethodId = fControl["paymentMethod"].value ? fControl["paymentMethod"].value.id : 0;
        creditMemo.paymentTermId = fControl["paymentTerm"].value ? fControl["paymentTerm"].value.id : 0;
        creditMemo.totalAmount = this.sumTotal;
        creditMemo.pendingCreditAmount = this.orderTotal;
        creditMemo.discountTypeId = this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked && fControl["discountType"].value ? (fControl["discountType"]?.value?.discountBy ?? 0) : 0;
        creditMemo.discountType = "";
        creditMemo.discountAmount = this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discount : 0;
        creditMemo.discountFinancialId = this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == fControl["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0;
        creditMemo.discountId = this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == fControl["discountType"]?.value?.id).map((value) => value.id)[0] : 0;
        creditMemo.discountRate = this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? (fControl["discountValue"]?.value ?? 0) : 0;
        creditMemo.discountName = "";
        creditMemo.taxId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.id : 0;
        creditMemo.tax = null;
        creditMemo.taxAmount = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0;
        creditMemo.taxName = "";
        creditMemo.taxRateTypeId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.typeId : 0;
        creditMemo.taxFinancialId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.financialAccountId : 0;
        creditMemo.shippingCharge = fControl["shippingChargeAmount"].value ? fControl["shippingChargeAmount"].value : 0;
        creditMemo.netAmount = this.orderTotal;
        creditMemo.creditMemoStatusId = fControl["creditMemoStatus"].value ? fControl["creditMemoStatus"].value.id : 0;
        creditMemo.shippingMethodId = fControl?.shippingMethod?.value?.id ?? 0;
        creditMemo.shippingFinancialId = fControl?.shippingMethod?.value?.financialAccountId ?? 0;
        creditMemo.shippingTermId = fControl["shippingTerm"].value ? fControl["shippingTerm"].value.id : 0;
        creditMemo.creditMemoProducts = this.prepareProductsListToUpdateCreditMemo();
        creditMemo.creditMemoNotes = this.getCreditMemoNotesObj();
        creditMemo.creditMemoAudits = this.getCreditMemoAuditsObj();
        creditMemo.customAttributeValues = this.setExistingCustomAttributes(customattributeList);
        creditMemo.configJson = "";
        creditMemo.statusId = fControl["statusId"].value ? 1 : 2;
        creditMemo.businessName = this.accountInfo?.businessName;
        creditMemo.channelId = fControl.accountChannel.value?.id;
        (creditMemo.currencyUnitId = this.accountInfo?.currencyId ?? 0), (creditMemo.exchangeRate = this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate), (creditMemo.additionalFeesId = this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.id ?? 0) : 0), (creditMemo.additionalRate = this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFee"]?.value ?? 0) : 0), (creditMemo.additionalAmount = this.templates?.labels_footer[7]?.isChecked ? this.totalAdditionalFee : 0), (creditMemo.additionalFeesFinancialId = this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0), (creditMemo.account = null);
        creditMemo.billingAddress = null;
        creditMemo.shippingAddress = null;
        creditMemo.warehouse = null;
        creditMemo.user = null;
        creditMemo.paymentMethod = null;
        creditMemo.paymentTerm = null;
        creditMemo.discountType = null;
        creditMemo.tax = null;
        creditMemo.shippingMethod = null;
        creditMemo.shippingTerm = null;
        creditMemo.creditMemoStatus = null;
        creditMemo.contact = null;
        creditMemo.shipContact = null;
        creditMemo.postingDate = this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.cmDetails?.postingDate ;
        creditMemo.postingMonth = this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.cmDetails?.postingMonth ;
        creditMemo.postingYear = this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.cmDetails?.postingYear ;
        this.appMainService.isShowSpinner("loadCreditMemo");
        this.salesOrderService
            .updateCreditMemo(creditMemo, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Credit Memo updated successfully...",
                });
                this.creditMemoDialogClose.emit(false);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    getCreditMemoAuditsObj(): any {
        let creditMemoAudits = null;
        const mValue = this.cmForm.controls["memo"].value;
        if (mValue && mValue != "") {
            creditMemoAudits = [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    creditMemoId: 0,
                    description: "",
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        comment: mValue,
                        isImportant: true,
                        organizationId: this.app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: this.app._saveDateTimeWithZone(new Date()),
                        validToDate: this.app._saveDateTimeWithZone(new Date()),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                },
            ];
        }
        return creditMemoAudits;
    }

    getCreditMemoNotesObj(): any {
        let creditMemoNotes = null;
        const vmValue = this.cmForm.controls["vendorMessage"].value;
        if (vmValue && vmValue != "") {
            creditMemoNotes = [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    creditMemoId: 0,
                    userId: this.app.user.userId,
                    user: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        comment: vmValue,
                        isImportant: true,
                        organizationId: this.app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: this.app._saveDateTimeWithZone(new Date()),
                        validToDate: this.app._saveDateTimeWithZone(new Date()),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: null,
                    },
                },
            ];
        }
        return creditMemoNotes;
    }

    setExistingCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: this.cmDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0] ? this.cmDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Credit Memo").id,
                    objectValue: this.cmDetails.id,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                    statusId: 1,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }
    setCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                    statusId: 1,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    modifyCustumAttributes(data) {
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }

    setCheckBoxValue(value) {
        const checkBox = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    onCustomUpload(files: File[], field) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    onChangeUom(data, event) {
        data.subTotal = 0;
        if (data.typeId != 4) {
            data.totalQuantity = Number(data.ordQty) * Number(event?.uomDetail?.value || 1);
            if (data.accountPriceTier?.length > 0) {
                data.price = this.utilityService.applyPriceBook(this.aggregateDiscount, data, data.totalQuantity);
                data.price = data.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
            let discount = 0;
            if (data?.taxType?.taxRate) {
                const tax = Number(Number(data.taxType.taxRate) / 100);
                data.taxAmount = Number(data.totalQuantity) * Number(data.price) * Number(tax);
            } else {
                data.taxAmount = 0;
            }
            data.subTotal = Number(data.totalQuantity) * Number(data.price) + Number(data.taxAmount);
            if (data?.discountType) {
                const disType = data.discountType;
                if ((disType.description == "%" || disType.description == "Percentage") && data.discount) {
                    discount = (Number(data.totalQuantity) * Number(data.price) * Number(data.discount)) / 100;
                    data.discountAmount = discount;
                } else if ((disType.description == "$" || disType.description == "Amount") && data.discount) {
                    discount = data.discount;
                    data.discountAmount = discount;
                }
            }
            data.subTotal = Number(data.subTotal) - Number(discount);
        }

        for (let prd of data.bundleDetails) {
            prd.subTotal = 0;
            //Bundle Items
            if (this.type == "CREATE") {
                prd.ordQty = Number(data.ordQty) * Number(prd.originalQty) * Number(event?.uomDetail?.value || 1);
            } else {
                prd.ordQty = Number(data.ordQty) * Number(event?.uomDetail?.value || 1);
            }
            prd.totalQuantity = Number(prd.ordQty) * Number(prd?.unit?.uomDetail?.value || 1);
            if (prd.accountPriceTier?.length > 0) {
                prd.price = this.utilityService.applyPriceBook(this.aggregateDiscount, prd, prd.totalQuantity);
                prd.price = prd.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
            if (prd?.taxType?.taxRate) {
                const tax = Number(Number(prd.taxType.taxRate) / 100);
                prd.taxAmount = Number(prd.totalQuantity) * Number(prd.price) * Number(tax);
            } else {
                prd.taxAmount = 0;
            }
            prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
            let discount = 0;
            if (prd?.discountType) {
                const disType = prd.discountType;
                if ((disType.description == "%" || disType.description == "Percentage") && prd.discount) {
                    discount = (Number(prd.totalQuantity) * Number(prd.price) * Number(prd.discount)) / 100;
                    prd.discountAmount = discount;
                } else if ((disType.description == "$" || disType.description == "Amount") && prd.discount) {
                    discount = prd.discount;
                    prd.discountAmount = discount;
                }
            }
            prd.subTotal = Number(prd.subTotal) - Number(discount);
            data.subTotal = data.subTotal + prd.subTotal;
        }
        this.findSum2();
    }

    onChangeBundleUom(bundle, data, event) {
        data.totalQuantity = Number(data.ordQty) * Number(event?.uomDetail?.value || 1);
        data.subTotal = Number(data.ordQty) * Number(event?.uomDetail?.value || 1) * Number(data.price);
        let total = 0;
        bundle.bundleDetails.forEach((e) => {
            total += e.subTotal;
        });
        bundle.price = total;
        bundle.subTotal = total;
        this.findSum2();
    }

    openProductsDialog() {
        this.moduleName = SOChannel.CREDIT_MEMO;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.purchaseListTB;
        this.selectedLocationId = this.cmForm.controls.location.value ? this.cmForm.controls.location.value.id : 0;
    }
    openProductsDialogForBundle(bundle) {
        this.moduleName = "Bundle";
        this.selectedBundle = bundle;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = bundle.bundleDetails;
        this.selectedLocationId = this.cmForm.controls.location.value ? this.cmForm.controls.location.value.id : 0;
    }
    onCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }

    onProductAddComplete(event) {
        this.displayProductSelectionModal = false;
        const updatedProducts = this.utilityService.convertProductPriceByExchangeRate(event, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
        this.purchaseListTB = this.productCalculationUtilityService.onProductSelectionComplete(this.moduleName, this.purchaseListTB, this.selectedBundle, updatedProducts, this.allTaxRates, this.footerTaxEnabled, this.isVisibleRowTax);
        this.sumTotal = 0;
        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                s?.bundleDetails?.forEach((bundleProduct) => {
                    this.onChangeBundleProductTaxOrDiscount(s, bundleProduct, "qty");
                });
            } else {
                this.onChangeProductTaxOrDiscount(s, "qty");
            }
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        }
        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.cmForm.controls.location.disable();
        }
        this.findSum2();
    }
    getDecimalPlacesCached(categoryId: number): number {
        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }
    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some((unit) => unit.id === categoryId && unit.name?.toLowerCase() === "count") ? 0 : this.qtyFractionDigits;
    }

    onChangeCurrencyRecalculateAmount() {
        this.purchaseListTB = this.utilityService.reConvertProductPriceByExchangeRate(this.purchaseListTB, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate, this.previousCurrencyExchangeRate);
        this.sumTotal = 0;
        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                s?.bundleDetails?.forEach((bundleProduct) => {
                    this.onChangeBundleProductTaxOrDiscount(s, bundleProduct, "qty");
                });
            } else {
                this.onChangeProductTaxOrDiscount(s, "qty");
            }
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        }
        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.cmForm.controls.location.disable();
        }
        this.findSum2();
        this.previousCurrencyExchangeRate = this.currencyExchangeRate;
    }

    removeProduct(i) {
        this.purchaseListTB.splice(i, 1);
        if (this.type == "CREATE" && this.purchaseListTB && this.purchaseListTB.length == 0) {
            this.cmForm.controls.location.enable();
        }
        this.findSum2();
    }

    removeBundleProduct(bundle, i) {
        this.purchaseListTB.forEach((e) => {
            if (e.id == bundle.id) {
                e.bundleDetails.splice(i, 1);
                let total = 0;
                e.bundleDetails.forEach((ib) => {
                    total += ib.subTotal;
                });
                e.price = total;
                e.subTotal = total;
            }
        });
        this.findSum2();
    }

    findSum2(type?: string) {
        if (type == "discounttype") {
            this.cmForm?.controls["discountValue"]?.setValue(this.cmForm?.controls["discountType"]?.value?.discountValue || 0);
        } else if (type == "totalAdditionalFeetype") {
            this.cmForm?.controls["additionalFee"]?.setValue(this.cmForm?.controls["additionalFeeType"]?.value?.discountValue || 0);
        }
        this.discount = 0;
        this.orderTotal = 0;
        this.sumTotal = 0;
        this.tax = 0;
        this.productsTotal = 0;
        this.totalAdditionalFee = 0;
        this.productsTotalAdditionalFee = 0;
        const disName = this.cmForm.controls["discountType"].value ? this.cmForm.controls["discountType"]?.value?.name : "";
        let disValue = this.cmForm.controls["discountValue"]?.value ? this.cmForm.controls["discountValue"]?.value : 0;
        const shipValue = this.cmForm.controls["shippingChargeAmount"].value ? Number(this.cmForm.controls["shippingChargeAmount"].value) : 0;

        /** Total */
        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                s?.bundleDetails?.forEach((b) => {
                    this.productsTotalAdditionalFee += Number(b.additionalFeeAmount);
                });
            } else {
                this.productsTotalAdditionalFee += Number(s.additionalFeeAmount);
            }
            this.sumTotal += Number(s.baseSubTotal);
            this.productsTotal += Number(s.subTotal);
        }

        /** Discount */
        if (disName == "%" || disName == "Percentage") {
            if (disValue > 100) {
                disValue = 100;
                this.cmForm?.controls["discountValue"]?.setValue(disValue);
            }
        } else if (disName == "$" || disName == "Amount") {
            if (disValue > Number(this.sumTotal)) {
                disValue = Number(this.sumTotal);
                this.cmForm?.controls["discountValue"]?.setValue(disValue);
            }
        }
        if (this.isVisibleRowDiscount && this.footerDiscountEnabled && this.isVisibleFooterDiscount) {
            if (disName == "%" || disName == "Percentage") {
                this.discount = Number(this.sumTotal * (Number(disValue) / 100));
            } else if (disName == "$" || disName == "Amount") {
                this.discount = Number(disValue);
            }
        } else {
            let discountTotal = 0;
            this.purchaseListTB.forEach((e) => {
                if (e.typeId == this.typeIds.BundleTypeId) {
                    e.bundleDetails.forEach((b) => {
                        discountTotal += Number(b.discountAmount);
                    });
                } else {
                    discountTotal += Number(e.discountAmount);
                }
            });
            this.discount = discountTotal;
        }

        /** Tax */
        if (this.isVisibleRowTax && this.footerTaxEnabled && this.isVisibleFooterTax) {
            if (this.sumTotal && this.taxRate) {
                this.tax = Number(this.sumTotal * (this.taxRate / 100));
            } else {
                this.tax = 0;
            }
        } else {
            let taxTotal = 0;
            this.purchaseListTB.forEach((e) => {
                if (e.typeId == this.typeIds.BundleTypeId) {
                    e.bundleDetails.forEach((b) => {
                        taxTotal += Number(b.taxAmount);
                    });
                } else {
                    taxTotal += Number(e.taxAmount);
                }
            });
            this.tax = taxTotal;
        }

        this.orderTotal = this.sumTotal;
        if (this.isVisibleRowTax && this.footerTaxEnabled && this.isVisibleFooterTax) {
            this.orderTotal += this.tax;
        }
        if (this.footerDiscountEnabled) {
            this.orderTotal -= this.discount;
        }

        /** Additional Fee */
        this.orderTotal += this.productsTotalAdditionalFee;
        this.totalAdditionalFee = this.utilityService.calculateOrderTotalAdditionalFee(this.cmForm?.controls["additionalFeeType"]?.value?.type?.name, this.cmForm?.controls["additionalFee"]?.value, this.orderTotal, this.purchaseListTB, this.templates?.labels_table[9]?.isChecked, this.templates?.labels_footer[7]?.isChecked);
        this.orderTotal += this.totalAdditionalFee;

        /** Shipping charge */
        this.orderTotal += shipValue;
    }

    getDiscountAmount(b, uomValue) {
        if (this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked) {
            const discount = b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(b.quantity) * Number(b.pricePerProduct)) : b.discountAmount;
            const actualDiscount = discount / uomValue;
            return b?.discountType?.description == "%" ? actualDiscount.toFixed(2) : discount.toFixed(2);
        } else {
            return 0;
        }
    }

    getTaxAmount(b) {
        let amount = 0;
        if (b.tax && b.tax.taxRate) {
            amount = (Number(b.tax.taxRate) / 100) * (Number(b.quantity) * Number(b.pricePerProduct));
        }
        return amount;
    }
    async getTaxByAddress(countryId: number, stateId: number) {
        const sellerTaxes = await lastValueFrom(this.salesOrderService.getTaxByAddress(this.orgHeadOfficeAddress?.address?.countryId, this.orgHeadOfficeAddress?.address?.stateId));
        const buyerTaxes = await lastValueFrom(this.salesOrderService.getTaxByAddress(countryId, stateId));
        this.allTaxRates = this.utilityService.getTaxByAddress(countryId, stateId, this.orgHeadOfficeAddress, sellerTaxes, buyerTaxes);
    }

    onChangeProductTaxOrDiscount(product, type) {
        const uomValue = product && product.unit && product.unit.uomDetail && product.unit.uomDetail.value ? product.unit.uomDetail.value : 1;
        product.totalQuantity = Number(product.ordQty) * Number(uomValue);
        product.totalCostPrice = Number(product.costPrice) * Number(product.totalQuantity);

        //Pricebook
        if (product.typeId != 4) {
            if ((type == "qty" || type == "uom") && product.accountPriceTier?.length > 0) {
                product.price = this.utilityService.applyPriceBook(this.aggregateDiscount, product, Number(product.ordQty) * Number(uomValue));
                product.price = product.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
        }
        this.utilityService.calculateProductsSubTotal(product, this.type, this.allTaxRates, SOChannel.CREDIT_MEMO, this.aggregateDiscount, this.isVisibleRowTax, this.footerTaxEnabled, 0, false, this.templates?.labels_table[9]?.isChecked);
        this.findSum2();
    }

    onChangeBundleProductTaxOrDiscount(bundle, product, type) {
        this.utilityService.onChangeBundleProductTaxOrDiscount(bundle, product, type, SOChannel.ESTIMATES, this.aggregateDiscount, this.allTaxRates, this.footerTaxEnabled, this.isVisibleRowTax);
        this.findSum2();
    }

    onChangeTax() {
        this.discount = 0;
        this.orderTotal = 0;
        this.sumTotal = 0;
        this.taxRate = this.cmForm.controls["tax"].value.taxRate;
        const disName = this.cmForm.controls["discountType"].value ? this.cmForm.controls["discountType"]?.value?.name : 0;
        for (let s of this.purchaseListTB) {
            this.sumTotal = this.sumTotal + s.subTotal; //0.00 + 600.00
        }

        if (disName == "%" || disName == "Percentage") {
            this.discount = Number(this.sumTotal * (Number(this.cmForm.controls["discountValue"]?.value) / 100));
        } else if (disName == "$" || disName == "Amount") {
            this.discount = Number(this.cmForm.controls["discountValue"]?.value);
        }
        this.tax = 0;
        if (this.sumTotal && this.taxRate) {
            this.tax = Number(this.sumTotal * (this.taxRate / 100));
        } else {
            this.tax = 0;
        }
        this.orderTotal = this.sumTotal + Number(this.cmForm.controls["shippingChargeAmount"].value) + this.tax - this.discount;
    }

    calculateProductsSubTotal(item, qty, type) {
        if (type == "discounttype") {
            item.discount = item?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            item.additionalFee = item?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            const uomValue = item?.unit?.uomDetail?.value || 1;
            item.price = item.baseSubTotal / (Number(item.ordQty) * Number(uomValue));
        }else if(type == "price" && item.price == 0){
            item.discount = 0;
            item.additionalFee = 0;
            item.discountType = null;
            item.additionalFeeType = null;
        }

        /**
         * If type is bundle, then first calculate ordQty & totalQuantity of a product inside bundle.
         * then calculate subtotal of a product and total of bundle
         */
        if (item.typeId == TypeIds.BundleTypeId) {
            const data = {
                aggregateDiscount: this.aggregateDiscount,
                zipCode: this.shippingAddressInfo?.address?.zipCode,
                stateId: this.shippingAddressInfo?.address?.stateId,
                allDiscounts: this.discountOptions,
                discountTypeId: this.cmForm.controls["discountType"]?.value?.id,
                allTaxRates: this.allTaxRates,
                channelName: SOChannel.CREDIT_MEMO,
                isEnabledRowTax: this.isVisibleRowTax,
                taxEnabled: this.footerTaxEnabled,
                isRowWiseAdditionalFeeEnabled: this.templates?.labels_table[9]?.isChecked ?? false,
            };
            this.productCalculationUtilityService.calculateQtyAndBundleProductsSubTotal(item, qty, this.allTaxRates, this.soChannel.ESTIMATES, this.type, this.footerTaxEnabled, this.isVisibleRowTax, data);
            this.findSum2();
        } else {
            this.onChangeProductTaxOrDiscount(item, type);
            this.findSum2();
        }
    }

    calculateBundleProductsSubTotal(bundle, item, qty, type) {
        if (type == "discounttype") {
            // item.discount = 0;
            item.discount = item?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            item.additionalFee = item?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            const uomValue = item?.unit?.uomDetail?.value || 1;
            item.price = item.baseSubTotal / (Number(item.ordQty) * Number(uomValue));
        }else if(type == "price" && item.price == 0){
            item.discount = 0;
            item.additionalFee = 0;
            item.discountType = null;
            item.additionalFeeType = null;
        }

        const uomValue = item && item.unit && item.unit.uomDetail && item.unit.uomDetail.value ? item.unit.uomDetail.value : 1;
        item.totalQuantity = Number(qty) * Number(uomValue);
        this.onChangeBundleProductTaxOrDiscount(bundle, item, type);
    }

    onDialogClose() {
        this.ovBodyAuto();
        this.cancel.emit(false);
    }
    confirmVoid() {
        this.confirm.emit(false);
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el.name === name)?.isRequired || false;
    }

    /**Tracking SerialNo**/

    openScanInfo(product) {
        this.allChecked = false;
        this.importForAllProducts = false;
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.refId = "";
        this.selectedProductForScan = _.cloneDeep(product);
        this.productSerialSettings = product.serialSettings;
        this.prepareTrackingForm();
        this.selectedBundleForScan = null;
        this.selectedKitForScan = null;
        this.displayScanInfo = true;
        const data = product.creditMemoProductSerialDetails && product.creditMemoProductSerialDetails.length > 0 ? product.creditMemoProductSerialDetails[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });

        const arr = [];
        if (product.creditMemoProductSerialDetails && product.creditMemoProductSerialDetails.length > 0) {
            product.creditMemoProductSerialDetails.forEach((element) => {
                const obj = {
                    id: element.id,
                    serialNo: element.barcode,
                    serialNo2: element.serialNumber2,
                    serialNo3: element.serialNumber3,
                    serialNo4: element.serialNumber4,
                    serialNo5: element.serialNumber5,
                    serialNo6: element.serialNumber6,
                    serialNo7: element.serialNumber7,
                    serialNo8: element.serialNumber8,
                    serialNo9: element.serialNumber9,
                    serialNo10: element.serialNumber10,
                    serialNo11: element.serialNumber11,
                    serialNo12: element.serialNumber12,
                    serialNo13: element.serialNumber13,
                    serialNo14: element.serialNumber14,
                    serialNo15: element.serialNumber15,
                    serialNo16: element.serialNumber16,
                    serialNo17: element.serialNumber17,
                    lotNo: element.lotNumber,
                    revisionNo: element.revisionNumber,
                    expiration: element.expirationDate,
                    systemPresent: true,
                    referenceId: this.refId,
                };
                arr.push(obj);
            });
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.checkSerialNoInSystem(this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, this.selectedCreditMemo?.id || 0);
        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator(["lotNo", "revisionNo", "expiration", "serialNo", "serialNo2", "serialNo3", "serialNo4", "serialNo5", "serialNo6", "serialNo7", "serialNo8", "serialNo9", "serialNo10", "serialNo11", "serialNo12", "serialNo13", "serialNo14", "serialNo15", "serialNo16", "serialNo17"]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    openScanInfoForBundle(bundle, product, mainProduct?) {
        this.allChecked = false;
        this.importForAllProducts = false;
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.refId = "";
        this.selectedProductForScan = _.cloneDeep(product);
        this.selectedBundleForScan = _.cloneDeep(bundle);
        this.selectedKitForScan = _.cloneDeep(mainProduct);
        this.productSerialSettings = product.serialSettings;
        this.prepareTrackingForm();
        this.displayScanInfo = true;
        const data = product.cmBundleProductSerialDetail && product.cmBundleProductSerialDetail.length > 0 ? product.cmBundleProductSerialDetail[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });

        const arr = [];
        if (product.cmBundleProductSerialDetail && product.cmBundleProductSerialDetail.length > 0) {
            product.cmBundleProductSerialDetail.forEach((element) => {
                const obj = {
                    id: element.id,
                    serialNo: element.barcode,
                    serialNo2: element.serialNumber2,
                    serialNo3: element.serialNumber3,
                    serialNo4: element.serialNumber4,
                    serialNo5: element.serialNumber5,
                    serialNo6: element.serialNumber6,
                    serialNo7: element.serialNumber7,
                    serialNo8: element.serialNumber8,
                    serialNo9: element.serialNumber9,
                    serialNo10: element.serialNumber10,
                    serialNo11: element.serialNumber11,
                    serialNo12: element.serialNumber12,
                    serialNo13: element.serialNumber13,
                    serialNo14: element.serialNumber14,
                    serialNo15: element.serialNumber15,
                    serialNo16: element.serialNumber16,
                    serialNo17: element.serialNumber17,
                    lotNo: element.lotNumber,
                    revisionNo: element.revisionNumber,
                    expiration: element.expirationDate,
                    systemPresent: true,
                    referenceId: this.refId,
                };
                arr.push(obj);
            });
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.checkSerialNoInSystem(this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, this.selectedCreditMemo?.id || 0);
        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator(["lotNo", "revisionNo", "expiration", "serialNo", "serialNo2", "serialNo3", "serialNo4", "serialNo5", "serialNo6", "serialNo7", "serialNo8", "serialNo9", "serialNo10", "serialNo11", "serialNo12", "serialNo13", "serialNo14", "serialNo15", "serialNo16", "serialNo17"]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    prepareTrackingForm() {
        const qty = this.selectedProductForScan?.totalQuantity;
        this.trackingForm = this.fb.group({
            qty: [qty - this.listLength, [Validators.required]],
            lotNo: [""],
            revisionNo: [""],
            expiration: [""],
            serialNo: [""],
            serialNo2: [""],
            serialNo3: [""],
            serialNo4: [""],
            serialNo5: [""],
            serialNo6: [""],
            serialNo7: [""],
            serialNo8: [""],
            serialNo9: [""],
            serialNo10: [""],
            serialNo11: [""],
            serialNo12: [""],
            serialNo13: [""],
            serialNo14: [""],
            serialNo15: [""],
            serialNo16: [""],
            serialNo17: [""],
            packageBarcode: [""],
        });
        /**set validation for Tracking form**/
        for (let opt of this.trackingOptions) {
            if (opt.enabled && (this.productSerialSettings ? this.productSerialSettings[`${opt.code}`] : true)) {
                if (opt.field !== "serialNo" && opt.isRequired) {
                    this.trackingForm?.get(`${opt.field}`).setValidators(Validators.required);
                } else if (opt.field === "serialNo" && opt.isRequired) {
                    if (this.utilityService.displayName("serializedChecked", this.trackingOptions, "control") == "InputBox") {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
                    } else {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required]);
                    }
                } else {
                    this.trackingForm?.get(`${opt.field}`).clearValidators();
                }
                this.trackingForm?.get(`${opt.field}`).updateValueAndValidity();
            }
        }
    }

    countNameList(value) {
        if (this.trackingForm.valid && this.listLength < this.selectedProductForScan?.totalQuantity) {
            if (value.serialNo) {
                value.serialNo = this.isPrefix ? this.prefixValue.concat(value.serialNo) : value.serialNo;
                const duplicate = this.autoGenerateLists?.filter((sr) => sr.serialNo == value.serialNo);
                for (let prd of this.purchaseListTB) {
                    const prdDuplicate = prd.creditMemoProductSerialDetails?.filter((sNo) => sNo.barcode == value.serialNo);
                    if (prdDuplicate?.length > 0) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Duplicate serialNo found.",
                        });
                        return;
                    }
                    //bundle items
                    if (prd.bundleDetails?.length > 0) {
                        for (let bundle of prd.bundleDetails) {
                            const bundleDuplicate = bundle.cmBundleProductSerialDetail?.filter((sNo) => sNo.barcode == value.serialNo);
                            if (bundleDuplicate?.length > 0) {
                                this.messageService.add({ severity: "error", summary: "Error", detail: "Duplicate serialNo found." });
                                return;
                            }
                            //kit under kit items
                            if (bundle.bundleDetails?.length > 0) {
                                for (let kp of bundle.bundleDetails) {
                                    const kitDuplicate = kp.cmBundleProductSerialDetail?.filter((sNo) => sNo.barcode == value.serialNo);
                                    if (kitDuplicate?.length > 0) {
                                        this.messageService.add({ severity: "error", summary: "Error", detail: "Duplicate serialNo found." });
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
                if (duplicate?.length > 0) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Serial No you tried to enter is already present in below list.",
                    });
                } else {
                    const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == value.serialNo);
                    if (present) {
                        value.systemPresent = true;
                        value.checked = false;
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
                    } else {
                        this.checkSerialsForSystem(this.trackingForm.controls["serialNo"].value, this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, value);
                    }
                }
            } else {
                const totalQty = this.selectedProductForScan?.totalQuantity;
                for (let i = 0; i < value.qty; i++) {
                    if (this.listLength < totalQty) {
                        this.autoGenerateLists.push({ ...value });
                        this.listLength++;
                    }
                }
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.totalTBRecord = this.listLength;
                this.trackingForm.controls["qty"].setValue(totalQty - this.listLength);
            }
        }
        const controlNames = Object.keys(this.trackingForm.controls);
        for (let ctrl of controlNames) {
            if (this.trackingOptions?.find((el) => el.field === ctrl)?.clearField) {
                this.trackingForm.controls[`${ctrl}`].setValue("");
            }
        }
    }

    checkSerialsForSystem(serialNo, productIds, warehouseId, value) {
        this.salesOrderService
            .checkSerialNoInAllSystem(serialNo, warehouseId, productIds, this.cmDetails?.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                if (!this.serialConfig?.childInventorySettings[0]?.enabled) {
                    if (res.allowSave) {
                        value.systemPresent = false;
                        value.checked = true;
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                    } else if (!res.allowSave || !res.isMatched) {
                        this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
                    } else {
                        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is not a part of this order and associated with other product,you can't add." });
                    }
                } else {
                    //auto-remove unmatched while save button
                    value.systemPresent = false;
                    value.checked = true;
                    value.remove = true;
                    this.autoGenerateLists.push(value);
                    this.nameLists = this.autoGenerateLists.slice(0, 100);
                    this.listLength = this.listLength + 1;
                    this.totalTBRecord = this.listLength;
                }
                this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
            });
    }

    removeNumber(i) {
        this.nameLists.splice(i, 1);
        this.autoGenerateLists.splice(i, 1);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength--;
        this.totalTBRecord = this.listLength;
        this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    deleteAll() {
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.listLength = 0;
        this.totalTBRecord = 0;
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    saveSerializedNo(c) {
        if (this.serialConfig?.childInventorySettings[0]?.enabled) {
            const arrayList = JSON.parse(JSON.stringify(this.autoGenerateLists));
            for (let serial of arrayList) {
                if (serial.remove) {
                    const index = this.autoGenerateLists?.indexOf(serial);
                    this.autoGenerateLists.splice(index, 1);
                }
            }
        }
        // bundle items
        if (this.selectedBundleForScan && this.selectedBundleForScan.typeId && (this.selectedBundleForScan.typeId == TypeIds.BundleTypeId || this.selectedBundleForScan.typeId == TypeIds.KitTypeId)) {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedBundleForScan.id) {
                    element.bundleDetails.forEach((b) => {
                        if (this.type == DialogType.CREATE) {
                            if (b.id == this.selectedProductForScan.id) {
                                b.cmBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        creditMemoId: 0,
                                        creditMemoProductId: 0,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        systemPresent: nl.systemPresent,
                                        expirationDate: nl.expiration,
                                        statusId: 1,
                                        shipped: true,
                                        referenceId: this.refId,
                                    };
                                    b.cmBundleProductSerialDetail.push(obj);
                                });
                            }
                        } else {
                            if (b.rowId == this.selectedProductForScan.rowId) {
                                b.cmBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        creditMemoId: 0,
                                        creditMemoProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                                        creditMemoBundleDetailId: b.rowId ? b.rowId : 0,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        systemPresent: nl.systemPresent,
                                        expirationDate: nl.expiration,
                                        statusId: 1,
                                        shipped: true,
                                        referenceId: this.refId,
                                    };
                                    b.cmBundleProductSerialDetail.push(obj);
                                });
                            }
                        }
                    });
                } else {
                    //kit under kit
                    for (let element of this.purchaseListTB) {
                        if (element.id == this.selectedKitForScan?.id) {
                            element.bundleDetails.forEach((k) => {
                                if (k.id == this.selectedBundleForScan?.id) {
                                    for (let kp of k.bundleDetails) {
                                        if (this.type == DialogType.CREATE) {
                                            if (kp.id == this.selectedProductForScan.id) {
                                                kp.cmBundleProductSerialDetail = [];
                                                this.autoGenerateLists.forEach((nl) => {
                                                    const obj = {
                                                        id: 0,
                                                        createdSource: this.app.userIP,
                                                        updatedSource: this.app.userIP,
                                                        createdBy: this.app.userId,
                                                        updatedBy: this.app.userId,
                                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                                        creditMemoId: 0,
                                                        creditMemoProductId: 0,
                                                        barcode: nl.serialNo,
                                                        serialNumber2: nl.serialNo2,
                                                        serialNumber3: nl.serialNo3,
                                                        serialNumber4: nl.serialNo4,
                                                        serialNumber5: nl.serialNo5,
                                                        serialNumber6: nl.serialNo6,
                                                        serialNumber7: nl.serialNo7,
                                                        serialNumber8: nl.serialNo8,
                                                        serialNumber9: nl.serialNo9,
                                                        serialNumber10: nl.serialNo10,
                                                        serialNumber11: nl.serialNo11,
                                                        serialNumber12: nl.serialNo12,
                                                        serialNumber13: nl.serialNo13,
                                                        serialNumber14: nl.serialNo14,
                                                        serialNumber15: nl.serialNo15,
                                                        serialNumber16: nl.serialNo16,
                                                        serialNumber17: nl.serialNo17,
                                                        lotNumber: nl.lotNo,
                                                        revisionNumber: nl.revisionNo,
                                                        systemPresent: nl.systemPresent,
                                                        expirationDate: nl.expiration,
                                                        statusId: 1,
                                                        shipped: true,
                                                        referenceId: this.refId,
                                                    };
                                                    kp.cmBundleProductSerialDetail.push(obj);
                                                });
                                            }
                                        } else {
                                            if (kp.rowId == this.selectedProductForScan.rowId) {
                                                kp.cmBundleProductSerialDetail = [];
                                                this.autoGenerateLists.forEach((nl) => {
                                                    const obj = {
                                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                                        createdSource: this.app.userIP,
                                                        updatedSource: this.app.userIP,
                                                        createdBy: this.app.userId,
                                                        updatedBy: this.app.userId,
                                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                                        creditMemoId: 0,
                                                        creditMemoProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                                                        creditMemoBundleDetailId: kp.rowId ? kp.rowId : 0,
                                                        barcode: nl.serialNo,
                                                        serialNumber2: nl.serialNo2,
                                                        serialNumber3: nl.serialNo3,
                                                        serialNumber4: nl.serialNo4,
                                                        serialNumber5: nl.serialNo5,
                                                        serialNumber6: nl.serialNo6,
                                                        serialNumber7: nl.serialNo7,
                                                        serialNumber8: nl.serialNo8,
                                                        serialNumber9: nl.serialNo9,
                                                        serialNumber10: nl.serialNo10,
                                                        serialNumber11: nl.serialNo11,
                                                        serialNumber12: nl.serialNo12,
                                                        serialNumber13: nl.serialNo13,
                                                        serialNumber14: nl.serialNo14,
                                                        serialNumber15: nl.serialNo15,
                                                        serialNumber16: nl.serialNo16,
                                                        serialNumber17: nl.serialNo17,
                                                        lotNumber: nl.lotNo,
                                                        revisionNumber: nl.revisionNo,
                                                        systemPresent: nl.systemPresent,
                                                        expirationDate: nl.expiration,
                                                        statusId: 1,
                                                        shipped: true,
                                                        referenceId: this.refId,
                                                    };
                                                    kp.cmBundleProductSerialDetail.push(obj);
                                                });
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }
                }
            });
        } else {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedProductForScan.id) {
                    element.creditMemoProductSerialDetails = [];
                    this.autoGenerateLists.forEach((nl) => {
                        const obj = {
                            id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            creditMemoId: 0,
                            creditMemoProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                            barcode: nl.serialNo,
                            serialNumber2: nl.serialNo2,
                            serialNumber3: nl.serialNo3,
                            serialNumber4: nl.serialNo4,
                            serialNumber5: nl.serialNo5,
                            serialNumber6: nl.serialNo6,
                            serialNumber7: nl.serialNo7,
                            serialNumber8: nl.serialNo8,
                            serialNumber9: nl.serialNo9,
                            serialNumber10: nl.serialNo10,
                            serialNumber11: nl.serialNo11,
                            serialNumber12: nl.serialNo12,
                            serialNumber13: nl.serialNo13,
                            serialNumber14: nl.serialNo14,
                            serialNumber15: nl.serialNo15,
                            serialNumber16: nl.serialNo16,
                            serialNumber17: nl.serialNo17,
                            lotNumber: nl.lotNo,
                            revisionNumber: nl.revisionNo,
                            systemPresent: nl.systemPresent,
                            expirationDate: nl.expiration,
                            statusId: 1,
                            shipped: true,
                            referenceId: this.refId,
                        };
                        element.creditMemoProductSerialDetails.push(obj);
                    });
                }
            });
        }
        this.selectedProductForScan = null;
        this.selectedBundleForScan = null;
        this.displayScanInfo = false;
    }

    openImport() {
        this.displayImport = true;
    }
    hideImport() {
        this.displayImport = false;
    }

    //Auto-Generate Serial Tracking
    generate(value) {
        for (let i = 0; i < (this.selectedProductForScan?.totalQuantity ? this.selectedProductForScan?.totalQuantity : 0) - this.listLength; i++) {
            value.serialNo = this.prefixValue.concat(this.utilityService.generateSerialNo(12 - this.prefixValue?.length));
            this.autoGenerateLists.push(JSON.parse(JSON.stringify(value)));
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.totalTBRecord = this.autoGenerateLists.length;
        }
        this.listLength = this.selectedProductForScan?.totalQuantity ? this.selectedProductForScan?.totalQuantity : 0;
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(event.first, event.first + event.rows);
        }
    }

    importSave(data) {
        this.refId = data.referenceId;
        const unique =
            data.list?.filter((obj) => {
                const autoIndex = this.autoGenerateLists.findIndex((item) => item.serialNo === obj.serialNo);
                const hasBlankSerialNo = this.autoGenerateLists.some((item) => item.serialNo === "");
                return autoIndex === -1 || hasBlankSerialNo;
            }) || [];

        const qty = this.selectedProductForScan?.totalQuantity - this.listLength;
        if (unique.length > 0 && data.list?.length - unique.length > qty) {
            this.confirmationService.confirm({
                message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
                header: "Alert Confirmation",
                icon: "pi pi-info-circle",
                accept: () => {
                    this.importSerialData(data);
                },
                reject: () => {},
            });
        } else {
            this.importSerialData(data);
        }
    }

    importSerialData(data) {
        this.unMatchedSerials = [];
        for (let dt of data.list) {
            if (dt.serialNo) {
                const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == dt.serialNo);
                if (present) {
                    dt.systemPresent = true;
                    dt.remove = false;
                    dt.checked = false;
                } else if (!present && this.serialConfig?.enabled) {
                    dt.systemPresent = false;
                    dt.remove = false;
                    dt.checked = true;
                } else if (!present || !this.serialConfig?.enabled) {
                    dt.systemPresent = true;
                    dt.checked = false;
                }
            } else {
                dt.systemPresent = true;
                dt.remove = false;
                dt.checked = false;
            }
            //this.autoGenerateLists.push(dt); /*new logic*/
            if (data.action == "add") {
                const index = this.autoGenerateLists?.findIndex((exp) => exp.serialNo == dt.serialNo);
                if (index > -1) {
                    dt.id = this.autoGenerateLists[index].id;
                    this.autoGenerateLists[index] = dt;
                } else {
                    if (this.listLength < this.selectedProductForScan?.totalQuantity) {
                        this.autoGenerateLists.push(dt);
                        this.listLength++;
                    }
                }
            } else {
                // Get the total quantity from the form control .
                const totalQty = this.selectedProductForScan.totalQuantity || 0;
                const filteredList = data.list.slice(0, totalQty);
                // Fields to skip when comparing
                const skipKeys = ["id", "expiration", "field1", "field2", "field3", "field4", "field5", "field6", "field7", "field8", "field9", "field10", "field11", "field12", "field13", "field14", "field15", "field16", "field17", "field18", "field19", "field20"];
                // Compare only defined + non-empty fields from newItem against existingItem
                const isMatch = (existingItem: any, newItem: any): boolean => {
                    for (const key in newItem) {
                        if (skipKeys.includes(key)) continue;

                        const newVal = newItem[key];
                        if (newVal !== undefined && newVal !== null && newVal !== "") {
                            if (existingItem[key] !== newVal) return false;
                        }
                    }
                    return true;
                };
                // Step 1: Update existing items
                let updatedList = this.autoGenerateLists.map((existingItem) => {
                    const match = filteredList.find((newItem) => isMatch(existingItem, newItem));
                    if (match) {
                        return {
                            ...existingItem,
                            ...Object.keys(match).reduce((acc, key) => {
                                acc[key] = match[key] !== undefined && match[key] !== "" ? match[key] : existingItem[key]; // preserve existing if new is blank
                                return acc;
                            }, {} as any),
                        };
                    }
                    return existingItem;
                });
                // Step 2: Remove items not found in filteredList
                updatedList = updatedList.filter((existingItem) => filteredList.some((newItem) => isMatch(existingItem, newItem)));
                // Step 3: Add new items not present in updatedList
                filteredList.forEach((newItem) => {
                    const exists = updatedList.some((existingItem) => isMatch(existingItem, newItem));
                    if (!exists) {
                        updatedList.push(newItem);
                    }
                });
                this.autoGenerateLists = updatedList;
            }
            this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.disabledSave = false;
        this.displayImport = false;
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Import successfully, removed duplicate Serial No.",
        });
    }

    checkSerialNoInSystem(productId, warehouseId, orderId) {
        this.salesOrderService.checkSerialNoInSystem(orderId, warehouseId, productId, "creditMemo").subscribe((data) => {
            this.systemTrackingData = data;
        });
    }

    /**End tracking SerialNo**/

    checkTaxDiscountVisibility() {
        this.isVisibleRowTax = !this.templates?.labels_table[5]?.isChecked;
        this.isVisibleRowDiscount = !this.templates?.labels_table[6]?.isChecked;
        this.isVisibleFooterTax = this.templates["labels_footer"] && this.templates["labels_footer"].length >= 3 ? this.templates["labels_footer"][2]?.isChecked : false;
        this.isVisibleFooterDiscount = this.templates["labels_footer"] && this.templates["labels_footer"].length >= 4 ? this.templates["labels_footer"][3]?.isChecked : false;
    }

    // todo cancel serial no

    isNumberKey(evt, product?, type?) {
        if (type == "price" || type == "baseSubtotal") {
            product.minPrice = 0;
            product.minBaseSubtotal = 0;
            if (product?.typeId == TypeIds.ServiceTypeId) {
                let inventoryOrNonInventoryProducts = this.purchaseListTB?.filter((p) => p?.typeId == TypeIds.InventoryTypeId || p?.typeId == TypeIds.NonInventoryTypeId);
                if (inventoryOrNonInventoryProducts && inventoryOrNonInventoryProducts?.length > 0) {
                    product.minPrice = -999999999999.9999;
                    product.minBaseSubtotal = -999999999999.9999;
                    return this.utilityService.allowPositiveOrNegativeNumber(evt);
                }
                return this.utilityService.allowPositiveNumberOnly(evt);
            }
            return this.utilityService.allowPositiveNumberOnly(evt);
        }
        return this.utilityService.allowPositiveNumberOnly(evt);
    }

    onEnterDownStopPropagation(event) {
        event.stopPropagation();
    }

    isClosingStatementDate(event: string) {
        this.statementMessege = event;
    }

    getColsCount() {
        this.cols = 0;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }
        this.cols -= 1; // todo include action column estimates templates.. after include remove this line.
    }

    onClearLocation() {
        if (this.allLocations && this.allLocations.length) {
            this.cmForm.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
    }

    setTableCheck() {
        for (let s of this.autoGenerateLists) {
            if (this.allChecked) {
                s.checked = true;
            } else {
                s.checked = false;
            }
        }
    }

    setMainHeaderTracking() {
        const checked = this.nameLists.filter((ch) => ch.checked == true);
        if (checked.length == this.nameLists?.length) {
            this.allChecked = true;
        } else {
            this.allChecked = false;
        }
    }

    replaceCommaLine(data) {
        let dataToArray = data.split(",").map((item) => item.trim());
        return dataToArray;
    }

    createCreditMemoFromRma(customattributeList) {
        this.isDisabled = true;
        const products = [];
        const fControl = this.cmForm.controls;
        this.appMainService.isShowSpinner("loadCreditMemo");
        this.purchaseListTB.forEach((product) => {
            // bundle items
            const bundleItems: ICreditMemoBundleProduct[] = [];
            let total = 0;
            let subTotal = 0;
            if (product.bundleDetails) {
                product.bundleDetails.forEach((e) => {
                    const obj: ICreditMemoBundleProduct = {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: e.description,
                        creditMemoId: 0,
                        productId: product.id,
                        subproductId: e.id,
                        parentProductId: 0,
                        parentBundleId: 0,
                        productUOMId: e?.unit?.unitOfMeasureId ?? 1,
                        availableQuantity: e.availabel,
                        quantity: e.ordQty,
                        pricePerProduct: e.price,
                        totalAmount: e.subTotal,
                        subTotal: e.baseSubTotal,
                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : 0,
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : 0,
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : 0,
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.id)[0] : 0,
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
                        discountName: "",
                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                        taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                        statusId: 1,
                        creditMemoProductId: 0,
                        creditMemoSerialNumber: null,
                        creditMemoBundleProductSerialDetail: e.cmBundleProductSerialDetail && e.cmBundleProductSerialDetail.length > 0 ? e.cmBundleProductSerialDetail : null,
                        binId: 0,
                        totalQty: e.totalQuantity,
                        additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: e.costPrice ?? 0,
                        totalCostPrice: e.totalCostPrice ?? 0,
                    };
                    total += Number(e.subTotal);
                    subTotal += Number(e.baseSubTotal);
                    bundleItems.push(obj);
                    /** kit under kit items **/
                    e.bundleDetails?.forEach((kp) => {
                        const obj: ICreditMemoBundleProduct = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            description: kp.description,
                            creditMemoId: 0,
                            productId: product.id,
                            subproductId: kp.id,
                            parentProductId: e.id,
                            parentBundleId: 0,
                            productUOMId: kp.unit?.unitOfMeasureId,
                            availableQuantity: kp.availabel,
                            quantity: kp.ordQty,
                            pricePerProduct: kp.price,
                            totalAmount: kp.subTotal,
                            subTotal: kp.baseSubTotal,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType.discountBy ?? 0) : 0,
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : 0,
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.incomeAccount)[0] : 0,
                            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.id)[0] : 0,
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : 0,
                            discountName: "",
                            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                            taxName: "",
                            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                            statusId: 1,
                            creditMemoProductId: 0,
                            creditMemoSerialNumber: null,
                            creditMemoBundleProductSerialDetail: kp.cmBundleProductSerialDetail && kp.cmBundleProductSerialDetail.length > 0 ? kp.cmBundleProductSerialDetail : null,
                            binId: 0,
                            totalQty: kp.totalQuantity,
                            additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                            additionalAmount: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                            additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                            costPrice: kp.costPrice ?? 0,
                            totalCostPrice: kp.totalCostPrice ?? 0,
                        };
                        bundleItems.push(obj);
                    });
                });
            }
            let productTotalAmountOfSubTotal = product.typeId == TypeIds.BundleTypeId ? subTotal : product.baseSubTotal;
            const obj: ICrediMemoProduct = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                description: product.description,
                creditMemoId: 0,
                productId: product.id,
                productUOMId: product?.unit?.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
                quantity: product.ordQty,
                quantityInStock: product.availabel,
                pricePerProduct: product.price,
                totalAmount: product.typeId == TypeIds.BundleTypeId ? total : product.subTotal,
                subTotal: productTotalAmountOfSubTotal,
                warehouseId: 0,
                statusId: 1,
                creditMemoSerialNumber: null,
                creditMemoProductSerialDetail: product.invoiceProductSerialDetails && product.invoiceProductSerialDetails.length > 0 ? product.invoiceProductSerialDetails : null,
                binId: 0,
                creditMemoBundleDetail: bundleItems && bundleItems.length > 0 ? bundleItems : [],
                totalQty: product.totalQuantity,
                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType.discountBy ?? 0) : 0,
                discountType: "",
                discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : 0,
                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : 0,
                discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.id)[0] : 0,
                discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                discountName: "",
                taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? product.taxAmount : 0,
                taxName: "",
                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                additionalFeesId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                additionalAmount: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                additionalFeesFinancialId: this.templates?.labels_table[9]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                costPrice: product.costPrice ?? 0,
                totalCostPrice: product.totalCostPrice ?? 0,
            };
            products.push(obj);
        });
        const req: ICreditMemo = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
            number: "",
            name: "",
            businessName: this.accountInfo?.businessName,
            referenceNumber: "",
            warehouseId: fControl["location"].value ? fControl["location"].value.id : 0,
            creditMemoDate: this.app._saveDateTimeWithZone(fControl["date"].value),
            expiryDate: this.app._saveDateTimeWithZone(fControl["expiryDate"].value),
            description: "",
            organizationId: this.app.companyId,
            accountId: fControl["account"].value ? fControl["account"].value.id : 0,
            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
            userId: fControl["salesRep"].value ? fControl["salesRep"].value.id : 0,
            paymentMethodId: fControl["paymentMethod"].value ? fControl["paymentMethod"].value.id : 0,
            paymentTermId: fControl["paymentTerm"].value ? fControl["paymentTerm"].value.id : 0,
            shippingMethodId: fControl?.shippingMethod?.value?.id ?? 0,
            shippingFinancialId: fControl?.shippingMethod?.value?.financialAccountId ?? 0,
            shippingTermId: fControl["shippingTerm"].value ? fControl["shippingTerm"].value.id : 0,
            salesRep: fControl["salesRep"].value ? fControl["salesRep"].value.id : 0,
            totalAmount: this.sumTotal,
            pendingCreditAmount: this.orderTotal,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked && fControl["discountType"].value ? (fControl["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == fControl["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == fControl["discountType"]?.value?.id).map((value) => value.id)[0] : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[3]?.isChecked ? (fControl["discountValue"]?.value ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.id : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked && fControl["tax"].value ? fControl["tax"].value.financialAccountId : 0,
            netAmount: this.orderTotal,
            shippingCharge: fControl["shippingChargeAmount"].value ? fControl["shippingChargeAmount"].value : 0,
            creditMemoStatusId: fControl["creditMemoStatus"].value ? fControl["creditMemoStatus"].value.id : 0,
            typeId: 1,
            statusId: fControl["statusId"].value ? 1 : 2,
            creditMemoNotes: this.getCreditMemoNotesObj(),
            creditMemoAudits: this.getCreditMemoAuditsObj(),
            creditMemoProducts: products,
            customAttributeValues: this.setCustomAttributes(customattributeList),
            configJson: "",
            createdByUser: "",
            channelId: fControl.accountChannel.value?.id,
            additionalFeesId: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[7]?.isChecked ? this.totalAdditionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[7]?.isChecked ? (fControl["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.cmForm.controls["date"].value),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (new Date(this.cmForm.controls["date"].value).getMonth() + 1),
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (new Date(this.cmForm.controls["date"].value).getFullYear()),
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
        };
        this.salesOrderService
            .createCreditMemo(req, this.isBaseCurrency(), this.selectedReturn.id, true)
            .then(() => {
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Credit Memo created successfully...",
                });
                this.creditMemoDialogClose.emit(false);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadCreditMemo");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    onAddNewContact(data) {
        this.appMainService.isShowSpinner("onAddNewContact");
        from(this.salesOrderService.getAccountDetailsById(this.accountInfo?.id)).subscribe(
            (data) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                this.accountInfo = data;
            },
            (error) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                console.error("Error fetching account details", error);
            },
        );
    }
    getAllTax() {
        this.salesOrderService.getAllTax().subscribe((res) => {
            this.footerTaxEnabled = res.item1;
            if (res.item1) {
                this.allTax = res.item2;
                if (this.allTax && this.allTax.length > 0) {
                    this.taxDesc = this.allTax.filter((t) => t.isDefault == true)[0];
                }
            }
        });
    }

    loadPaymentTerm() {
        this.appMainService.isShowSpinner("loadPaymentTerm");
        this.paymentTermService
            .getPaymentTermList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadPaymentTerm");
                    this.allPaymentTerms = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadPaymentTerm");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadPaymentMethod() {
        this.appMainService.isShowSpinner("loadPaymentMethod");
        this.paymentMethodService
            .getPaymentMrthodList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadPaymentMethod");
                    this.allPaymentMethods = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadPaymentMethod");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadShippingTerm() {
        this.appMainService.isShowSpinner("loadShippingTerm");
        this.shippingtermService
            .getShippingTermList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.allShippingTerms = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllUser() {
        this.appMainService.isShowSpinner("loadAllUser");
        this.salesOrderService
            .getAllUser()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.allUser = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllLocation() {
        this.allLocations = [];
        this.appMainService.isShowSpinner("loadAllLocation");
        this.salesOrderService
            .getAllLocations("0", "0", "")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    if (res && res.length > 0) {
                        this.allLocations = res?.map((l) => ({
                            ...l,
                            name: l.locationId + " - " + l.name,
                            contactName: l.contactPersonName,
                            qty: l.qtyInStock,
                        }));
                        if (this.type == DialogType.CREATE) {
                            this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                            this.cmForm.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
                        }
                    }
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadOrderChannels(name) {
        this.appMainService.isShowSpinner("loadChannels");
        this.salesOrderService
            .getAllOrdersChannel(name)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    const config = JSON.parse(res.configurationDetails[0].configJSONValue);
                    this.orderChannels = config;
                    const filteredStatus = this.orderChannels?.filter((s) => s.name == this.soChannel.CREDIT_MEMO)[0].status;
                    this.allStatus = filteredStatus;

                    if (this.type == DialogType.CREATE) {
                        this.cmForm.controls["creditMemoStatus"].setValue(this.allStatus[0]);
                    }
                    this.appMainService.isHideSpinner("loadChannels");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadChannels");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    getDiscountSelection(name) {
        this.appMainService.isShowSpinner("getDiscountSelection");
        this.salesOrderService
            .getAllDiscountOption(name)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
                    this.aggregateDiscount = aggregateDiscountValue ? true : false;
                    this.appMainService.isHideSpinner("getDiscountSelection");
                },
                error: () => {
                    this.appMainService.isHideSpinner("getDiscountSelection");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllTiers() {
        this.appMainService.isShowSpinner("loadAllTiers");
        this.productsService
            .getAllTiers()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.pricebookConfig = res.item1;
                    this.appMainService.isHideSpinner("loadAllTiers");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllTiers");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }

    /**
     *
     */
    setAllTaxData(res) {
        this.footerTaxEnabled = res?.item1;
        if (res?.item1) {
            this.allTax = res.item2;
            if (this.allTax && this.allTax.length > 0) {
                this.taxDesc = this.allTax.filter((t) => t.isDefault == true)[0];
            }
        }
    }
    setShippingTermData(res) {
        if (res) {
            this.allShippingTerms = res;
        }
    }
    setAllUserData(res) {
        if (res) {
            this.allUser = res;
        }
    }
    setAllLocationData(res) {
        this.allLocations = [];
        if (res && res.length > 0) {
            this.allLocations = res?.map((l) => ({
                ...l,
                name: l.locationId + " - " + l.name,
                contactName: l.contactPersonName,
                qty: l.qtyInStock,
            }));
            if (this.type == DialogType.CREATE) {
                this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                this.cmForm.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
            }
        }
    }
    setOrderChannelData(res) {
        if (res) {
            const config = JSON.parse(res.configurationDetails[0].configJSONValue);
            this.orderChannels = config;
            const filteredStatus = this.orderChannels?.filter((s) => s.name == this.soChannel.CREDIT_MEMO)[0].status;
            this.allStatus = filteredStatus;

            if (this.type == DialogType.CREATE) {
                this.cmForm.controls["creditMemoStatus"].setValue(this.allStatus[0]);
            }
        }
    }
    setDiscountSelectionData(res) {
        if (res) {
            const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
            this.aggregateDiscount = aggregateDiscountValue ? true : false;
        }
    }
    setAllTiersData(res) {
        if (res) {
            this.pricebookConfig = res.item1;
        }
    }
    setAdditionalDiscounts(addDiscounts) {
        this.discountOptions = [];
        this.additionalDiscounts = [];
        if (addDiscounts && addDiscounts.length > 0) {
            this.additionalDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
            this.additionalDiscountRateTypes = [];
            this.discountOptions = this.utilityService.prepareDiscountOptions(addDiscounts);
        }
    }
    setAdditionalFees(addFees) {
        this.additionalFees = addFees?.map((l) => ({ ...l, additionalname: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
    }

    onDateSelect(e) {
        if (this.cmForm.controls["date"].value) {
            this.minExpiryDate = this.app._showDateTimeWithZone(this.cmForm.controls["date"].value);
            this.cmForm.controls["expiryDate"].setValue(new Date(this.minExpiryDate));
        }
    }

    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    onAccountViewClick(e) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = e?.id ?? 0;
        this.selectedAccountChannelId = this.cmForm.controls.accountChannel.value?.id;
    }
    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
    }
    reloadResultAfterSave() {
        this.selectAccount({ id: this.selectedAccountId });
    }
    getPickListValues(values) {
        return values;
    }

    ovBodyAuto() {
        let body = document.getElementsByTagName("body")[0];
        body.classList.remove("overflow-hidden");
        body.classList.add("overflow-auto");
    }

    ovBodyHidden() {
        let body = document.getElementsByTagName("body")[0];
        body.classList.remove("overflow-auto");
        body.classList.add("overflow-hidden");
    }

    // find section by code
    getFilteredSectionsByType(code: string): string {
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    setContentInEditor(text: any) {
        setTimeout(() => {
            const _quill = this.editor?.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, "innerHTML", text);
        });
    }

    /** Multicurrency */
    getcurrencyExchangeRate() {
        this.currencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        this.previousCurrencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        if (this.type && (this.type == DialogType.EDIT || this.type == DialogType.COPY)) {
            this.currencyExchangeRate = this.savedCurrencyExchangeRate;
            this.previousCurrencyExchangeRate = this.savedCurrencyExchangeRate;
        }
    }

    closeCurrencyDialog(event) {
        this.currencyExchangeRate = event?.formData?.exchangeRate;
        if (event?.formData?.enableRecalculateItemRate) {
            this.onChangeCurrencyRecalculateAmount();
        }
        this.overlayPanel.hide();
    }

    isBaseCurrency(): boolean {
        return this.baseCurrency?.currencyId == this.accountInfo?.currencyId;
    }
    //open tracking list
    openTracking() {
        this.displayTracking = true;
    }

    closeTracking() {
        this.displayTracking = false;
    }
    saveTracking(data) {
        // Create a new object by adding the three fields
        for (let dt of data) {
            const newValue = {
                ...dt,
                id: 0, // Spread the existing data properties
                systemPresent: true, // Add systemPresent field
                remove: false, // Add remove field
                checked: false, // Add checked field
            };
            const presentSerialNo = this.autoGenerateLists?.find((nos) => nos.serialNo == dt.serialNo);
            if (!presentSerialNo && this.listLength < this.selectedProductForScan?.ordQty) {
                this.autoGenerateLists.push(newValue);
                this.listLength = this.listLength + 1;
            }
        }
        this.trackingForm.controls["qty"].setValue(this.selectedProductForScan?.ordQty - this.listLength);
        this.nameLists = this.autoGenerateLists?.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.displayTracking = false;
    }
    
    // footer level & line level fee & discount start
    getSelectedFee(): Fee | null {
        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE) {
            return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.selectedHProduct?.additionalFeeType : this.selectedDProduct?.discountType;
        } else {
            return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.cmForm?.controls["additionalFeeType"]?.value : this.cmForm?.controls["discountType"]?.value;
        }
    }

    getFeeList(): Fee[] {
        if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
            return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelHandlingFees : this.footerLevelHandlingFees;
        } else {
            return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelDiscounts : this.footerLevelDiscounts;
        }
    }

    openFooterLevelDiscount() {
        this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
        this.footerLevelDiscounts = this.additionalDiscounts.filter((d) => d.discountCategoryId === 2 && d.statusId == 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
        this.displayFeeOrDiscountDialog = true;
    }

    openLineLevelDiscount(product: any) {
        this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
        this.selectedDProduct = product || null;
        this.lineLevelDiscounts = this.discountOptions.filter((d) => d.discountCategoryId === 1 && d.statusId == 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
        this.displayFeeOrDiscountDialog = true;
    }

    applyDiscount(discount: any) {
        const discountValue = discount?.discountValue ?? 0;

        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE) {
            this.selectedDProduct.discountType = discount;
            this.selectedDProduct.discount = discountValue;
            this.calculateProductsSubTotal(this.selectedDProduct, this.selectedDProduct.ordQty, "discounttype");
        } else {
            const appliedDiscount = discount ? { ...discount, name: discount?.type?.name ?? "" } : null;
            this.cmForm.controls["discountType"].setValue(appliedDiscount);
            this.cmForm.controls["discountValue"].setValue(discountValue);
            this.findSum2("discounttype");
        }
        this.displayFeeOrDiscountDialog = false;
    }

    openFooterLevelHandlingFees() {
        this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
        this.footerLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 2);
        this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
        this.displayFeeOrDiscountDialog = true;
    }

    openLineLevelHandlingFees(product: any) {
        this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
        this.selectedHProduct = product;
        this.lineLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
        this.displayFeeOrDiscountDialog = true;
    }

    applyHandlingFee(fee: any) {
        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE) {
            this.selectedHProduct.additionalFeeType = fee;
            this.selectedHProduct.additionalFee = fee?.discountValue ?? 0;
            this.calculateProductsSubTotal(this.selectedHProduct, this.selectedHProduct.ordQty, "additionalFeeType");
        } else {
            this.cmForm.controls["additionalFeeType"].setValue(fee);
            this.cmForm.controls["additionalFee"].setValue(fee?.discountValue || 0);
            this.findSum2();
        }
        this.displayFeeOrDiscountDialog = false;
    }

    onFeeApply(event: Fee): void {
        if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
            this.applyHandlingFee(event);
        } else {
            this.applyDiscount(event);
        }
    }
    // footer level & line level fee & discount end

    // Posting period
    onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
    }
}
